/*
 * Copyright rphaven.com
 * Not for modification or use elsewhere
 */

import $ from 'jquery'
import 'jplayer'
import { createApp as createVue, reactive, watch, nextTick as vueNextTick } from 'vue'
import Anchorme from 'anchorme'
import IdleTimer from 'idle-timer'
import { createPopper } from '@popperjs/core'
import { delegate as delegateTippy } from 'tippy.js'
/* import '../css/new2020.css';
import '../css/nodechat2020.css'; */
// import jPlayerSwf from '<node_modules>/jplayer/dist/jplayer/jquery.jplayer.swf';

import rph from './rph.js'
import socket from './socket.js'
import settings from './settings.js'
import account from './account.js'
import { db, initDb } from './db.js'
import accountFns from './account-functions'
import { imgUrl, getUserById, getUserByName } from '../js/user-functions.js'
import { makeTimestamp, makeSafeForCss, quoteAttr, unquoteAttr } from './shared/common-functions.js'

import FriendsList from '../components/friends-list.vue'
import Settings from '../components/rph-settings.vue'
import MessageRollerVue from '../components/message-roller.vue'
import BadgeSetterVue from '../components/setter-user-badge.vue'
import loginFormVue from '../components/rph-login.vue'
import DataLoader from 'dataloader'
import UserState from '../components/user-state.vue'

import normalize from 'normalize.css'
import varboilerplate from '../../../varboilerplate/dist/varboilerplate.css'

// global.db
const _getUserById = getUserById,
	_getUserByName = getUserByName

$( function(){
	delegateTippy( 'body', {
		target: '[title]',
		content( reference ){
			const title = reference.getAttribute( 'title' )
			reference.removeAttribute( 'title' )

			return title
		}
	})

	if( typeof io === 'undefined' && window.console ){
		console.log( 'socket.io isn\'t started' )
	}

	const _emit = socket.emit,
		_onevent = socket.onevent,
		outgoingFns = {}

	function triggerOutgoing( ev, data ){
		( outgoingFns[ev] || [] ).forEach( ( fn ) => {
			fn( data )
		})
	}
	socket.onOutgoing = ( ev, fn ) => {
		outgoingFns[ev] = ( outgoingFns[ev] || [] ).concat( fn )
	}

	socket.emit = function(){ // sending
		const msgs = Array.prototype.slice.call( arguments ),
			data = msgs[1] || false

		triggerOutgoing( msgs[0], data )

		if( data && data.target && data.target === 'local' ){
			return false
		}
		_emit.apply( socket, arguments )
	}
	socket.onevent = function(){ // receiving
		const msgs = Array.prototype.slice.call( arguments )[0].data,
			data = msgs[1] ? msgs[1] : false

		// if( data && data.target && data.target === 'all' ){
		// const ms = new Date().getTime()// a unique key
		// localStorage_setItem(ms, arguments);
		_onevent.apply( socket, arguments )
		// } else {
		//	_onevent.apply( socket, arguments )
		// }
	}

	/*const usersById = new Map()
		usersByName = new Map(),
		usernames = [],
		userids = []*/

	async function batchGetUser( keys ){
		return await Promise.all(
			keys.map( async( key ) => {
				let user
				if( typeof key === 'string' ){
					user = await _getUserByName( key )
				} else {
					user = await _getUserById( key )
				}

				if( user ){
					return await new User( user )
				} else {
					return new Error( 'could not get user' )
				}
			})
		)
	}

	class DualCache extends Map{
		async set( key, value ){
			const val = await value

			if( val && val.props ){
				super.set( val.props.name, val )
				return super.set( val.props.id, val )
			}
		}
	}

	const userCache = new DualCache(),
		userByIdLoader = new DataLoader( async( keys ) => {
			return await batchGetUser( keys )
		}, {
			cacheMap: userCache
		}),
		userByNameLoader = new DataLoader( async( keys ) => {
			return await batchGetUser( keys )
		}, {
			cacheMap: userCache
		})

	global.userCache = userCache

	async function getUserById( userid, callback ){
		userid = parseInt( userid )
		return await userByIdLoader.load( userid )
			.then( ( user ) => {
				callback && callback( user )
				return user
			})
			.catch( ( err ) => {
				throw err
			})
	}
	async function getUserByName( username, callback ){
		return await userByNameLoader.load( username )
			.then( ( user ) => {
				callback && callback( user )
				return user
			})
			.catch( ( err ) => {
				throw err
			})
	}
	global.getUserById = getUserById
	global.getUserByName = getUserByName

	global.messenger = {},
	messenger.users = {},
	global.account = account
	global.rph = rph
	let connected = false
	const activeWindow = false
	$.fn.filterFind = function(){
		return this.filter.apply( this, arguments ).add(
			this.find.apply( this, arguments ) )
	}
	$.fn.isInViewport = function( $viewport ){
		const $this = $( this )
		if( !$this.length ){
			return false
		}
		const elementTop = this[0].offsetTop,
			elementBottom = elementTop + $( this ).outerHeight(),
			viewportTop = $viewport.scrollTop(),
			viewportBottom = viewportTop + $viewport.height()
		return elementBottom > viewportTop && elementTop < viewportBottom
	}
	$.fn.typing = function( options ){ return this.each( function( i, elem ){ listenToTyping( elem, options ) }) }; function listenToTyping( elem, options ){ var settings = $.extend({start: null, stop: null, delay: 400}, options ), $elem = $( elem ), typing = false, delayedCallback; function startTyping( event ){ if( !typing && event.which != 13 ){ typing = true; if( settings.start ){ settings.start( event, $elem ) } } else { if( event.which === 13 ){ typing = false; if( settings.stop ){ settings.stop( event, $elem ) } } } } function stopTyping( event, delay ){ if( typing ){ clearTimeout( delayedCallback ); delayedCallback = setTimeout( function(){ typing = false; if( settings.stop ){ settings.stop( event, $elem ) } }, delay >= 0 ? delay : settings.delay ) } }$elem.keypress( startTyping ); $elem.keydown( function( event ){ if( event.keyCode === 8 || event.keyCode === 46 ){ startTyping( event ) } }); $elem.keyup( stopTyping ); $elem.blur( function( event ){ stopTyping( event, 0 ) }) }
	$.fn.insertAtCaret = function( text, opts ){
		var element = $( this ).get( 0 ); if( document.selection ){
			element.focus(); var orig = element.value.replace( /\r\n/g, '\n' ), range = document.selection.createRange(); if( range.parentElement() != element ){ return !1 }
			range.text = text; var actual = tmp = element.value.replace( /\r\n/g, '\n' ); for( var diff = 0; diff < orig.length; diff++ ){ if( orig.charAt( diff ) != actual.charAt( diff ) ) break }
			for( var index = 0, start = 0; tmp.match( text ) && ( tmp = tmp.replace( text, '' ) ) && index <= diff; index = start + text.length ){ start = actual.indexOf( text, index ) }
		} else if( typeof element.selectionStart !== 'undefined' ){ var start = element.selectionStart, end = element.selectionEnd; element.value = element.value.substr( 0, start ) + text + element.value.substr( end, element.value.length ) } else if( document.getSelection() && document.getSelection().anchorNode ){
			element.focus(); anchorNode = document.getSelection().anchorNode; focusNode = document.getSelection().focusNode; if( !$( anchorNode ).closest( element ).length || anchorNode != focusNode ){ return !1 }
			origContent = anchorNode.textContent; anchorOffset = document.getSelection().anchorOffset || 0; focusOffset = document.getSelection().focusOffset || 0; if( anchorOffset == focusOffset ){ anchorNode.textContent = [origContent.slice( 0, anchorOffset ), text, origContent.slice( anchorOffset )].join( '' ) } else { anchorNode.textContent = [origContent.slice( 0, anchorOffset ), text, origContent.slice( focusOffset )].join( '' ) }
			return this
		}
		if( typeof start !== 'undefined' ){ setCaretTo( element, start + text.length ) } else { element.value = text + element.value }
		return this
	}
	$.fn.setCaretPosition = function( start, end ){ var element = $( this ).get( 0 ); element.focus(); setCaretTo( element, start, end ); return this }
	$.fn.getCaretPosition = function(){ var element = $( this ).get( 0 ); $( element ).focus(); return getCaretPosition( element ) }
	$.fn.getSelectedText = function(){ var element = $( this ).get( 0 ); if( typeof element.selectionStart !== 'undefined' ){ return $( element ).val().substr( element.selectionStart, element.selectionEnd - element.selectionStart ) } else if( document.getSelection ){ return document.getSelection() } else if( window.getSelection ){ return window.getSelection() } }
	function setCaretTo( element, start, end ){ if( typeof element.createTextRange !== 'undefined' ){ var range = element.createTextRange(); range.moveStart( 'character', start ); range.moveEnd( 'character', ( end || start ) ); range.select() } else if( typeof element.selectionStart !== 'undefined' ){ element.focus(); element.setSelectionRange( start, ( end || start ) ) } }
	function getCaretPosition( element ){ if( typeof element.selectionStart !== 'undefined' ){ return element.selectionStart } else if( document.selection ){ var range = document.selection.createRange(), rangeLength = range.text.length; range.moveStart( 'character', -element.value.length ); return range.text.length - rangeLength } }

	function playSound(){
		if( account.settings.imVolume > 0 ){
			rph.sounds.im.play()
		}
	}

	function unixtime(){
		return Math.round( Date.now() / 1000 )
		// return Date.now();
	}

	let lastNotification = false,
		focused = true
	$( window ).on( 'blur', function(){ focused = false })
		.on( 'focus', function(){
			focused = true
			if( lastNotification ){ lastNotification.cancel() }
		})
	function desktopNotify( title, body ){
		return false //remove it for now
		if( activeWindow && !focused ){
			if( window.webkitNotifications ){
				if( window.webkitNotifications.checkPermission() === 0 ){ // 0 is PERMISSION_ALLOWED
					const origLen = body.length
					body = body.substring( 0, 60 )
					if( body.length < origLen ){ body = body + '...' }
					if( lastNotification ){ lastNotification.cancel() } // close the old one so there is never more than one.
					lastNotification = webkitNotifications.createNotification( 'null.png', title, body )
					lastNotification.show()
				} else {
					// alert('You haven\'t set permissions for desktop notifications in settings.');
					if( console.log ) console.log( window.webkitNotifications )
				}
			}
		}
	}

	let idle = false
	function idleEnd(){
		if( idle ){
			socket.emit( 'idle-end' )
			idle = false
		}
	}
	IdleTimer({
		// function to fire after idle
		callback: () => {
			if( !idle ){
				socket.emit( 'idle-start' )
				idle = true
			}
		},
		// function to fire when active
		activeCallback: idleEnd,
		// Amount of time in milliseconds before becoming idle. default 60000
		idleTime: 60 * 10 * 1000
	})

	const $dock = $( '<div class="container dock"><div class="inner" /></div>' ).appendTo( 'body' ),
		$friendsList = $( `<div id="vue-friends">
				<friends-list ref="friends" />
			</div>` ).hide().appendTo( $dock.find( '.inner' ) ),
		$topBtns = $( '<div id="top-buttons" />' ).hide().prependTo( $dock.find( '.inner' ) ),
		$dockBtns = $( '<div id="dock-buttons" />' ).hide().appendTo( $dock.find( '.inner' ) ),
		$msgsBtn = $( '<a id="open-messages">Messages<span class="notifications"><span class="num" style="display:none">0</span></span></a>' ).appendTo( $dockBtns ),
		$friendsBtn = $( '<a id="open-friends"><span class="num">&nbsp;</span> Friends</a>' ).appendTo( $dockBtns )

	$( '<span class="reconnecting">Not connected. <a href="//www.rphaven.com/login.php">Login</a></span>' ).prependTo( $dock.find( '.inner' ) )
	$friendsBtn.on( 'click', function( ev ){
		$dock.find( '.inner' ).children().not( '#dock-buttons' ).toggle()
		if( $( '#top-buttons' ).is( ':visible' ) ){
			$( '#not-mainChat textarea' ).css({paddingLeft: '205px'})
		} else {
			$( '#not-mainChat textarea' ).css({paddingLeft: '2px'})
		}
	})

	global.friendsVue = createVue({
		components: {
			FriendsList
		},
		mounted(){
			watch(
				() => this.$refs.friends.onlineFriends,
				( items, oldItems ) => {
					$friendsBtn.find( '.num' ).text( items.length )
				}
			)
		}
	})
		.mount( '#vue-friends' )

	function UserSelector(){
		const thisObj = this
		this.$el = $( '<div id="user-selector" class="user-selector ui-corner-all"><p>Perform action as:</p><div class="users" /><button style="background:rgba(200,50,25,0.6);" class="no-border-radius-top">CANCEL</button></div>' )
			.hide().prependTo( 'body' )
		this.$el.find( 'button' ).button().on( 'click', function(){
			thisObj.$el.hide()
		})

		this.callback = function(){}
		this.setPrevUser = function( User ){
			this.$el.find( '.prev-user' ).remove()
			$( '<button class="prev-user no-border-radius-bottom">Use Last Selection (' + ( User.props.vanity || User.props.name ) + ( User.props.vanity ? ' <span class="small">a.k.a. ' + User.props.name + '</span>' : '' ) + ')</button>' ).button().on( 'click', function(){
				thisObj.callback( User )
				thisObj.$el.hide()
			})
				.insertAfter( this.$el.find( 'p:eq(0)' ) )
		}

		const $users = $( '<ul />' ).appendTo( this.$el.find( '.users' ) ),
			$favUsers = $( '<ul />' ).appendTo( this.$el.find( '.users' ) )

		this.attachTo = async function( $target, callback, Room ){
			this.$el.show()
			$users.empty()
			$favUsers.empty()
			this.callback = callback

			let accountUsers = account.userids
			if( Room ){
				const modsAndOwners = Room.props.owners.concat( Room.props.mods )
				accountUsers = accountUsers.filter( ( userid ) => {
					return modsAndOwners.includes( userid )
				}) // array contains array
			}

			await Promise.all(
				accountUsers.map( async( userid ) => {
					await getUserById( userid, ( accountUser ) => {
						if( accountUsers.length === 1 ){
							callback.call( thisObj, accountUser )
							thisObj.$el.hide()
							return
						}

						const $userSel = $( `<li><picture><img class="thumb" src="${imgUrl( accountUser )}" /></picture><a class="username">${accountUser.props.name}</a></li>` ),

							$favBtn = $( '<a class="fav">&nbsp;<span class="tip">Set profile as a favorite, pinning it to the bottom of this list</span></a>' ),
							$favedBtn = $( '<a class="faved">&nbsp;<span class="tip">Remove from favorites</span></a>' ),
							addFav = function(){
								if( !Array.isArray( account.settings.favUsers ) ) account.settings.favUsers = [] // can safely remove this later... some were being set as integers
								!account.settings.favUsers.includes( accountUser.props.id ) && account.settings.favUsers.push( accountUser.props.id )
								account.settings.set( 'favUsers', account.settings.favUsers )
							},
							rmFav = function(){
								const foundi = account.settings.favUsers.indexOf( accountUser.props.id )
								console.log( 'rmFav', foundi, foundi !== -1, account.settings.favUsers )
								account.settings.favUsers.splice( foundi, foundi !== -1 )

								account.settings.set( 'favUsers', account.settings.favUsers )
							}
						$userSel.on( 'click', '.fav', function( ev ){
							$userSel.find( '.fav' ).remove()
							$favedBtn.prependTo( $userSel )
							addFav()
						})
						$userSel.on( 'click', '.faved', function( ev ){
							$userSel.find( '.faved' ).remove()
							$favBtn.prependTo( $userSel )
							rmFav()
						})

						if( !account.settings.favUsers.includes( accountUser.props.id ) ){
							$userSel.appendTo( $users )
							// alphabetical insert
							$users.find( 'li' ).each( function(){
								const $this = $( this )
								if( accountUser.props.name < $this.find( '.username' ).text() ){
									$userSel.insertBefore( $this )
									return false
								}
							})
							$favBtn.prependTo( $userSel )
						} else {
							$userSel.appendTo( $favUsers )
							$favedBtn.prependTo( $userSel )
						}

						$userSel.find( 'img, .username' ).on( 'click', function( ev ){
							thisObj.setPrevUser( accountUser )
							callback.call( thisObj, accountUser )
							thisObj.$el.hide()
						})
					})
				})
			)
				.catch( ( err ) => {
					console.log( 'promise all err', err )
				})
			this.$el.find( '.users' ).scrollTop( this.$el.find( '.users' )[0].scrollHeight )
			this.$el.position({my: 'center bottom', at: 'center top', of: $target, collision: 'flip flip'})
			thisObj.$el.position({my: 'center bottom', at: 'center top', of: $target, collision: 'flip flip'})
		}
		return this
	}
	rph.UserSelector = new UserSelector()

	const $notifications = $( '#rph-notifications' )
	rph.notification = function( title, contents, opts ){
		const thisObj = this
		opts = typeof opts === 'object' ? opts : {}
		contents = typeof contents !== 'undefined' ? contents : ''
		title = typeof title !== 'undefined' ? title : ''

		this.$el = $( '<div class="rph-notification"><h3>' + title + '</h3><p>' + contents + '</p></div>' ).appendTo( $notifications )

		if( opts.lifetime ){
			setTimeout( function(){
				thisObj.remove()
			}, opts.lifetime )
		}

		this.remove = function(){
			this.$el.addClass( 'hide' ).delay( 400 ).queue( function(){
				$( this ).remove()
			})
		}

		return this
	}
	rph.PointerInput = function( $target ){
		const thisPointer = this,
			pointerHtml = '<div class="floating-container"><div class="arrow">&nbsp</div>' +
					'	<div class="container" style="width:200px;"><div style="background:#fff;">' +
					'		<div class="input-button-combo">' +
					'			<input type="text" placeholder="Input name" class="ui-corner-all" autocomplete="off" />' +
					'			<button title="New PM" class="new-pm"><span class="ui-icon ui-icon-circle-triangle-e"></span></button>' +
					'		</div>' +
					'	</div></div>' +
					'</div>',
			$el = $( pointerHtml ).hide().prependTo( 'body' )
		this.$el = $el
		// $el.show();
		// $el.position({of: $target, my: 'left top', at: 'left bottom', offset: '-10px 8px'});

		$( document ).on( 'mouseup', function( ev ){
			if( $el.has( ev.target ).length === 0 ){ $el.hide() }
		})

		this.attachTo = function( $target ){
			$el.show()
			$el.find( 'input' ).val( '' )
			$el.position({of: $target, my: 'left top', at: 'left bottom', offset: '-10px 8px'})
			$el.find( 'input' ).focus()
			return this
		}
		this.onSubmit = function( fn ){
			$el.find( 'input' ).off().on( 'keydown', function( ev ){
				if( ev.keyCode === 13 ){
					fn.call( thisPointer )
					$el.hide()
				}
			})
			$el.find( 'button' ).off().on( 'click', function( ev ){
				fn.call( thisPointer )
				$el.hide()
			})
			return this
		}
		this.prop = function( propName, value ){
			$el.find( 'input' ).prop( propName, value )
			return this
		}
		this.val = function(){
			return $el.find( 'input' ).val()
		}
		return this
	}
	rph.PointerInput = new rph.PointerInput()

	$.extend( $.ui.dialog.prototype.options, {
		autoOpen: false,
		height: 350,
		width: 500,
		buttons: {}
	})
	rph.CustomDialog = function( name, html, opts ){
		const thisObj = this
		opts = typeof opts === 'object' ? opts : {}
		html = typeof html !== 'undefined' ? html : ''
		this.onOpenFn = function(){}
		this.onCloseFn = function(){}

		this.$el = $( '<div id="' + makeSafeForCss( name ) + '-dialog" title="' + name + '"><div class="inner" /></div>' ).dialog( opts )

		if( opts && opts.closeOnEscape === false ){
			this.$el.parent().find( '.ui-dialog-titlebar-close' ).hide()
		}

		this.contents = function( html ){
			this.$el.find( '.inner' ).empty().append( html )
			return this
		}
		this.show = function(){
			try {
				this.$el.dialog( 'open' )
			} catch( e ){
				console.log( 'dialog show error...', this, this.$el )
			}
			this.onOpenFn()
			return this
		}
		this.hide = function(){
			this.$el.dialog( 'close' )
			this.onCloseFn()
			return this
		}
		this.addButton = function( obj ){
			const buttons = thisObj.$el.dialog( 'option', 'buttons' )
			$.extend( buttons, obj )
			thisObj.$el.dialog( 'option', 'buttons', buttons )
			return this
		}
		this.buttons = function( obj ){
			thisObj.$el.dialog( 'option', 'buttons', obj )
			return this
		}
		this.onOpen = function( callback ){
			this.$el.on( 'dialogopen', callback )
			this.onOpenFn = callback
		}
		this.onClose = function( callback ){
			this.$el.on( 'dialogclose', callback )
			this.onCloseFn = callback
		}

		this.contents( html )
		rph.dialogs[name] = rph.dialogs[name] || this
		return thisObj
	}
	rph.getDialog = function( name ){
		return rph.dialogs[name] || new CustomDialog( name )
	}

	// The HTML for the coins to use
	const template = $( `<div class="coin" style="visibility:hidden;">
		<img class="coinHeads" src="https://www.rphaven.com/css/images/coin-heads.svg" />
		<img class="coinEdge" src="https://www.rphaven.com/css/images/coin-edge.svg" />
		<img class="coinLine" src="https://www.rphaven.com/css/images/coin-line.svg" />
		<img class="coinTails" src="https://www.rphaven.com/css/images/coin-tails.svg" />
	</div>` ),

		// Animation setup
		getFlippage = ( coin, whatSide ) => {
		// define jumping
			const jumpTime = Math.random() + 1.0,
				jumpTl = new TimelineMax(),
				jumpUp = new TweenMax( coin, jumpTime,
					{y: -60, rotation: Math.random() * 20 - 10, ease: Power1.easeOut}),
				jumpDown = new TweenMax( coin, jumpTime / 2,
					{y: 0, ease: Bounce.easeOut})

			jumpTl
				.add( jumpUp.play() )
				.add( jumpDown.play() )

			// timeline for each
			return new TimelineMax()
				.add( whatSide, 0 ) // picks whether to land on heads or tails
				.add( jumpTl, 0 )
		},

		headsFlip = ( coin ) => { // generate animation timeline
			const flipTime = 1 / 4,
				headsTl = new TimelineMax({ repeat: 1 })

			headsTl
				.fromTo( coin.heads, flipTime,
					{scaleY: 1, y: 0}, {scaleY: 0, y: 0},
					'headEnd' )
				.fromTo( coin.heads, flipTime,
					{scaleY: 1, y: 0}, {scaleY: 0, y: 8},
					'headEnd' )
				.fromTo( coin.line, flipTime,
					{height: 0, y: 0}, {height: 8, y: 0},
					'headEnd' )

				.to( coin.heads, 0,
					{y: 0},
					'tailStart' )
				.fromTo( coin.tails, flipTime,
					{opacity: 1, scaleY: 0, y: 8}, {opacity: 1, scaleY: 1, y: 0},
					'tailStart' )
				.to( coin.edge, flipTime,
					{scaleY: 1, y: 0},
					'tailStart' )
				.to( coin.line, flipTime,
					{height: 0, y: 0},
					'tailStart' )

				.to( coin.tails, flipTime,
					{scaleY: 0},
					'tailEnd' )
				.fromTo( coin.edge, flipTime,
					{scaleY: 1, y: 0}, {scaleY: 0, y: 8},
					'tailEnd' )
				.to( coin.line, flipTime,
					{height: 8, y: 0},
					'tailEnd' )
				.fromTo( coin.heads, flipTime,
					{scaleY: 0, y: 8}, {scaleY: 1, y: 0},
					'headStart' )
				.fromTo( coin.edge, flipTime,
					{scaleY: 0, y: 0}, {scaleY: 1, y: 0},
					'headStart' )
				.to( coin.line, flipTime,
					{height: 0, y: 0},
					'headStart' )

			return headsTl
		},

		tailsFlip = ( coin ) => { // need to fix the head/tails flipping around.. test in slow motion
			const flipTime = 1 / 2,
				tailsTl = new TimelineMax({ repeat: 1 })

			tailsTl
				.fromTo( coin.heads, flipTime,
					{scaleY: 1, y: 0}, {scaleY: 0, y: 0},
					'headEnd2' )
				.fromTo( coin.edge, flipTime,
					{scaleY: 1, y: 0}, {scaleY: 0, y: 8},
					'headEnd2' )
				.fromTo( coin.line, flipTime,
					{height: 0, y: 0}, {height: 8, y: 0},
					'headEnd2' )

				.to( coin.edge, 0,
					{y: 0},
					'tailStart2' )
				.fromTo( coin.tails, flipTime,
					{opacity: 1, scaleY: 0, y: 8}, {opacity: 1, scaleY: 1, y: 0},
					'tailStart2' )
				.to( coin.edge, flipTime,
					{scaleY: 1, y: 0},
					'tailStart2' )
				.to( coin.line, flipTime,
					{height: 0, y: 0},
					'tailStart2' )

			return tailsTl
		},

		animateRolls = ( rolls ) => {
			const coins = [],
				flips = [],
				coinTl = new TimelineMax() // master timeline

			rolls.forEach( ( resultAndDie ) => {
				if( resultAndDie[1] == 2 ){ // is d2, so coinflip
					flips.push( resultAndDie[0] )
				}
			})

			flips.forEach( ( flip, i ) => {
				const clone = template.clone().attr( 'class', 'coinBox' ),
					imgs = clone.find( 'img' ),
					coin = {
						index: i,
						box: clone, // append these after returned
						heads: imgs[0],
						edge: imgs[1],
						line: imgs[2],
						tails: imgs[3],
						flip: function(){
							var side = Math.random() > 0.5 ? headsFlip( this ) : tailsFlip( this )
							return getFlippage( this.box, side )
						}
					}

				TweenLite.set( coin.box, { y: 0, autoAlpha: 1 })

				if( flip === 1 ){ // 1 is heads, 2 is tails;
					coinTl.add( getFlippage( coin.box, headsFlip( coin ) ), 0 )
				} else {
					coinTl.add( getFlippage( coin.box, tailsFlip( coin ) ), 0 )
				}

				coins.push( coin )
			})

			return coins
		}

	global.appendRollResult = ( $message, rolls, animate ) => {
		const resultStrings = [],
			numbers = []
		rolls.forEach( ( resultAndDie ) => {
			if( Array.isArray( resultAndDie ) ){
				if( resultAndDie[1] == 2 ){
					resultStrings.push( resultAndDie[0] == 1 ? 'Heads' : 'Tails' )
				} else {
					resultStrings.push( resultAndDie[0] == resultAndDie[1] ? resultAndDie[0] + '<sub><strong>(d' + resultAndDie[1] + ')</strong></sub>' : resultAndDie[0] + '<sub>(d' + resultAndDie[1] + ')</sub>' )
				}
			} else {
				resultStrings.push( resultAndDie )
			}
			numbers.push( resultAndDie[0] || resultAndDie ) // may not be a 2d array if it's just a number to add
		})

		if( animate ){ // coin flip animation
			if( animate === 'DEFAULT' ){
				template.find( '.coinHeads' ).attr( 'src', 'https://www.rphaven.com/css/images/coin-heads.svg' )
				template.find( '.coinTails' ).attr( 'src', 'https://www.rphaven.com/css/images/coin-tails.svg' )
			} else if( animate === 'GYATE_FOX_COIN_SKIN' ){
				template.find( '.coinHeads' ).attr( 'src', 'https://img.rphaven.com/gyate-fox-coin-heads.svg' )
				template.find( '.coinTails' ).attr( 'src', 'https://img.rphaven.com/gyate-fox-coin-tails.svg' )
			}

			const coins = animateRolls( rolls ), // only animates d2
				$cointainer = $( '<div class="cointainer" />' ).appendTo( $message.closest( '.message-line' ).find( '.message-right' ) )

			coins.forEach( ( coin ) => {
				coin.box.appendTo( $cointainer )
			})
		}

		if( $message.has( '.roll-result' ).length === 0 ){
			$message.html( $message.html() +
				'<p class="roll-result" style="text-align:right; margin-right:10px">' +
					( numbers.length === 1 ? '<span class="large">' : '' ) + // style where the large number appears, either on the sum or the single result
					resultStrings.join( '+' ) +
					( numbers.length > 1 ? '=<span class="large">' + numbers.reduce( ( sum, current ) => sum + current, 0 ) : '' ) +
					'</span>' +
				'</p>' )
			$message.closest( '.msgs' ).animate({scrollTop: '+=' + ( $message.parent().outerHeight() )}, 180 )
		}
	}
	socket.on( 'roll', ( data ) => {
		let $line
		if( data.roomname ){
			$line = getRoom( data.roomname ).$el.find( '.timestamp[data-unixtime="' + data.msgid + '"][data-userid="' + data.userid + '"]' ).closest( '.message-line' )
		} else {
			$line = $( '#pm-dialog' ).find( '.timestamp[data-unixtime="' + data.msgid + '"][data-userid="' + data.userid + '"]' ).closest( '.message-line' )

			db.msgs.where({fromid: data.userid, date: parseInt( data.msgid )}).toArray() // update logs with roll
				.then( ( rows ) => {
					rows.forEach( ( row ) => {
						row.roll = data.roll,
						row.animate = data.animate
						db.msgs.put( row )
					})
				})
				.catch( ( err ) => console.log( err ) )

			// db.msgs.where({userid:pm.from.props.id, otherid:pm.to.props.id}) //how logs are gotten...
			// &[date+fromid+userid]
			/* db.msgs.where('[date+fromid+userid]').between([parseInt(data.msgid), data.userid, -Infinity], [parseInt(data.msgid), data.userid, Dexie.maxKey])
			.toArray()
			.then( rows => {
				console.log('rows...', rows);
			})
			.catch(err => console.log(err)) */
		}

		const $message = $line.find( '.message' )

		appendRollResult( $message, data.roll, data.animate )
	})

	global.editMessage = ( $message, msg, date ) => { // why does editing in ™ break edits?
		const originalMessage = 'originally: ' + $message.text()
		if( $message.parent().find( '.edited' )[0] ){
			// $message.parent().find('.edited').attr('title')
			$message.parent().find( '.edited' ).text( 'edited ' + makeTimestamp( date ) )
		} else {
			$( '<div class="edited small right-text" title="' + originalMessage + '">edited ' + makeTimestamp( date ) + '</div>' )
				.appendTo( $message.parent() )
		}
		$message.attr( 'data-unparsed', msg )
		$message.html( parseMsg( msg ) )
		$message.closest( '.msgs' ).animate({scrollTop: '+=' + ( $message.parent().outerHeight() )}, 180 )
	}
	socket.on( 'edit', ( data ) => {
		let $line
		if( data.roomname ){
			$line = getRoom( data.roomname ).$el.find( '.timestamp[data-unixtime="' + data.msgid + '"][data-userid="' + data.userid + '"]' ).closest( '.message-line' )
		} else {
			$line = $( '#pm-dialog' ).find( '.timestamp[data-unixtime="' + data.msgid + '"][data-userid="' + data.userid + '"]' ).closest( '.message-line' )

			db.msgs.where({fromid: data.userid, date: parseInt( data.msgid )}).toArray() // update logs with roll
				.then( ( rows ) => {
					rows.forEach( ( row ) => {
						row.newMsg = data.newMsg,
						row.editDate = data.editDate

						db.msgs.put( row )
					})
				})
				.catch( ( err ) => console.log( err ) )
		}

		const $message = $line.find( '.message' )

		editMessage( $message, data.newMsg, data.editDate )
	})

	rph.colorPicker = new rph.CustomDialog( 'Set Color',
		`<div><div id="swatch" class="ui-corner-all right - for finding RP.">
				<div class="dark-preview"><span>On Dark BG:</span><span class="name">Sample name</span></div>
				<div class="light-preview"><span>On Light BG:</span><span class="name">Sample name</span></div><p>#<span class="hexcolor">123456</span></p>
				</div>
			<div id="hue" max="360" />
			<div id="saturation" max="100" />
			<div id="luminosity" min="40" max="100" /></div>
			<p id="bright-notification" style="visibility:visible;">Dark colors have more constrained lower luminosity levels</p>
			<div class="fade-config">
				<div class="subscriber-lockout-modal">
					<h3><a>Subscribe</a> to unlock color fades</h3>
				</div>
				<div class="colors"><label><span class="hexcolor">fefefe</span> <a class="button">Apply color</a></label> <label><span class="hexcolor">111111</span> <a class="button">Apply color</a></label> <label><span class="hexcolor">111111</span> <a class="button">Apply color</a></label></div>
				<div class="fades"><label for="vertical-fade"><input type="checkbox" id="vertical-fade" autocomplete="off" /><a class="vertical-fade vertical-fade two-color name">Vertical</a></label> <label for="horizontal-fade"><input type="checkbox" id="horizontal-fade" autocomplete="off" /><a class="horizontal-fade horizontal-fade two-color name">Horizontal</a></label> <label for="radial-fade"><input type="checkbox" id="radial-fade" autocomplete="off" /><a class="radial-fade radial-fade two-color name">Radial</a></label> <label for="no-fade"><input type="checkbox" id="no-fade" checked="true" autocomplete="off" /><a class="no-fade name">None</a></label></div>
				<div class="num-colors"><label for="two-color-fade"><input type="checkbox" id="two-color-fade" class="two-color-fade-checkbox" autocomplete="off" /><span class="two-color name">Two-color Fade</span></label><label for="three-color-fade"><input type="checkbox" id="three-color-fade" class="three-color-fade-checkbox" autocomplete="off" /><span class="three-color name">Three-color Fade</span></label></div>
				</div>
			</div>
			<button class="submit" style="position:absolute; bottom:3px; right:3px">Confirm Color</button>`,
		{draggable: false, resizable: false, width: 440, height: 195})
	rph.colorPicker.hex = '111111'
	rph.colorPicker.$el.find( '.colors label' ).each( function( i ){
		const $this = $( this )
		$this.find( 'a.button' ).on( 'click', function( ev ){
			ev.preventDefault()
			console.log( 'set', rph.colorPicker.hex )
			$this.find( '.hexcolor' ).text( rph.colorPicker.hex ).css( 'color', '#' + rph.colorPicker.hex )
			rph.colorPicker['color' + ( i + 1 )] = rph.colorPicker.hex
			rph.colorPicker.$el.find( '.name' ).each( function(){
				this.style.setProperty( '--color' + ( i + 1 ), '#' + rph.colorPicker.hex )
			})
			rph.colorPicker.User.props.color[i] = rph.colorPicker.hex
		})
	})
	rph.colorPicker.$el.find( 'label' ).each( function( i ){
		const $label = $( this )
		if( $label.find( 'input[type=checkbox]' )[0] ){
			$label.on( 'click', function( ev ){
				console.log( 'clicked a label', ev.target )
				let $checkbox = $label.find( 'input[type=checkbox]' )
				if( ev.target !== $label.find( 'input[type=checkbox]' )[0] ){
					$checkbox.prop( 'checked', !$checkbox.prop( 'checked' ) ).change()
				} else {
					$checkbox = $label.find( 'input[type=checkbox]' ).prop( 'checked', true )
				}
			})
		}
	})
	rph.colorPicker.$el.find( '#vertical-fade, #horizontal-fade, #radial-fade' ).on( 'change', function( ev ){
		if( rph.colorPicker.$el.find( '.num-colors input[type=checkbox]:checked' ).length === 0 ){
			rph.colorPicker.$el.find( '.two-color-fade-checkbox' ).prop( 'checked', true ).change()
		}
	})
	rph.colorPicker.$el.find( '#vertical-fade' ).on( 'change', function( ev ){
		if( $( this ).prop( 'checked' ) ){
			rph.colorPicker.$el.find( '#swatch .name, .num-colors .name' ).addClass( 'vertical-fade' )
			rph.colorPicker.$el.find( '.fades input[type=checkbox]' ).not( '#vertical-fade' ).prop( 'checked', false ).change()
			rph.colorPicker.User.props.fade = 1
		} else {
			rph.colorPicker.$el.find( '#swatch .name, .num-colors .name' ).removeClass( 'vertical-fade' )
		}
	})
	rph.colorPicker.$el.find( '#horizontal-fade' ).on( 'change', function( ev ){
		if( $( this ).prop( 'checked' ) ){
			rph.colorPicker.$el.find( '#swatch .name, .num-colors .name' ).addClass( 'horizontal-fade' )
			rph.colorPicker.$el.find( '.fades input[type=checkbox]' ).not( '#horizontal-fade' ).prop( 'checked', false ).change()
			rph.colorPicker.User.props.fade = 2
		} else {
			rph.colorPicker.$el.find( '#swatch .name, .num-colors .name' ).removeClass( 'horizontal-fade' )
		}
	})
	rph.colorPicker.$el.find( '#radial-fade' ).on( 'change', function( ev ){
		if( $( this ).prop( 'checked' ) ){
			rph.colorPicker.$el.find( '#swatch .name, .num-colors .name' ).addClass( 'radial-fade' )
			rph.colorPicker.$el.find( '.fades input[type=checkbox]' ).not( '#radial-fade' ).prop( 'checked', false ).change()
			rph.colorPicker.User.props.fade = 3
		} else {
			rph.colorPicker.$el.find( '#swatch .name, .num-colors .name' ).removeClass( 'radial-fade' )
		}
	})
	rph.colorPicker.$el.find( '#no-fade' ).on( 'change', function( ev ){
		if( $( this ).prop( 'checked' ) ){
			rph.colorPicker.$el.find( '#swatch .name, .num-colors .name' ).removeClass( 'vertical-fade horizontal-fade radial-fade' )
			rph.colorPicker.$el.find( '.fades input[type=checkbox]' ).not( '#no-fade' ).prop( 'checked', false ).change()
			rph.colorPicker.User.props.fade = 0
			rph.colorPicker.$el.find( '.num-colors input[type=checkbox]' ).prop( 'checked', false ).change() // uncheck since only using 1 color
		}
	})
	rph.colorPicker.$el.find( '.fade-config input.two-color-fade-checkbox' ).on( 'change', function( ev ){
		if( $( this ).prop( 'checked' ) ){
			rph.colorPicker.colors = 2
			rph.colorPicker.$el.find( '.three-color-fade-checkbox' ).prop( 'checked', false )
			rph.colorPicker.$el.find( '#swatch .name, .fades .name' ).removeClass( 'three-color' ).addClass( 'two-color' )
		} else {
			rph.colorPicker.$el.find( '.three-color-fade-checkbox' ).prop( 'checked', true ).change()
		}
	})
	rph.colorPicker.$el.find( '.fade-config input.three-color-fade-checkbox' ).on( 'change', function( ev ){
		if( $( this ).prop( 'checked' ) ){
			rph.colorPicker.colors = 3
			rph.colorPicker.$el.find( '.two-color-fade-checkbox' ).prop( 'checked', false )
			rph.colorPicker.$el.find( '#swatch .name, .fades .name' ).removeClass( 'two-color' ).addClass( 'three-color' )
		} else {
			rph.colorPicker.$el.find( '.two-color-fade-checkbox' ).prop( 'checked', true ).change()
		}
	})
	rph.colorPicker.$el.find( '.hexcolor' ).on( 'click', function( ev ){
		ev.preventDefault()
		const $this = $( this )
		rph.PointerInput.attachTo( $this ).prop( 'placeholder', '######' ).onSubmit( function(){
			let inputHex = this.val()
			if( inputHex.charAt( 0 ) === '#' ){
				inputHex = inputHex.slice( 1 )
			}
			rph.colorPicker.setAsHex( inputHex )
			if( $this.closest( 'label' )[0] ){
				$this.closest( 'label' ).find( 'a.button' ).click()
			}
		})
	})
	rph.colorPicker.setUser = function( User ){
		rph.colorPicker.User = User
		rph.colorPicker.hex = User.props.color[0]
		rph.colorPicker.setAsHex( rph.colorPicker.hex )

		rph.colorPicker.$el.find( '.colors .hexcolor' ).each( function( i ){
			$( this ).text( rph.colorPicker.User.props.color[i] || rph.colorPicker.User.props.color[0] )
				.css( 'color', '#' + ( rph.colorPicker.User.props.color[i] || rph.colorPicker.User.props.color[0] ) )
			rph.colorPicker.$el.find( '.name' ).each( function(){
				this.style.setProperty( '--color' + ( i + 1 ), '#' + ( rph.colorPicker.User.props.color[i] || rph.colorPicker.User.props.color[0] ) )
			})
		})

		if( User.props.fade ){
			if( User.props.fade === 1 ){
				rph.colorPicker.$el.find( '#vertical-fade' ).prop( 'checked', true ).change()
			} else if( User.props.fade === 2 ){
				rph.colorPicker.$el.find( '#horizontal-fade' ).prop( 'checked', true ).change()
			} else if( User.props.fade === 3 ){
				rph.colorPicker.$el.find( '#radial-fade' ).prop( 'checked', true ).change()
			}
		}
		if( User.props.color.length > 1 ){
			if( User.props.color.length === 2 ){
				rph.colorPicker.$el.find( '.two-color-fade-checkbox' ).prop( 'checked', true ).change()
			} else if( User.props.color.length === 3 ){
				rph.colorPicker.$el.find( '.three-color-fade-checkbox' ).prop( 'checked', true ).change()
			}
		}

		return this
	}
	rph.colorPicker.setAsHex = function( hex ){
		const hsl = rph.colorPicker.hslFromHex( hex )
		$( '#hue' ).slider( 'value', parseInt( hsl[0] ) )
		$( '#saturation' ).slider( 'value', parseInt( hsl[1] ) )
		$( '#luminosity' ).slider( 'value', parseInt( hsl[2] ) )
		rph.colorPicker.$el.find( '#swatch' ).css( 'color', '#' + rph.colorPicker.User.props.color[0] )
		rph.colorPicker.$el.find( '#swatch .name' ).text( rph.colorPicker.User.props.name )
		rph.colorPicker.$el.find( '.no-fade' ).css( 'color', '#' + rph.colorPicker.User.props.color[0] )
	}
	rph.colorPicker.hexFromRgb = function( r, g, b ){
		const hex = [r.toString( 16 ), g.toString( 16 ), b.toString( 16 )]
		hex.forEach( function( val, ni ){
			if( val.length === 1 ){
				hex[ni] = '0' + val
			}
		})
		return hex.join( '' ).toUpperCase()
	}
	rph.colorPicker.rgbFromHex = function( hex ){
		return [parseInt( hex.slice( 0, 2 ), 16 ), parseInt( hex.slice( 2, 4 ), 16 ), parseInt( hex.slice( 4, 6 ), 16 )]
	}
	rph.colorPicker.hslFromHex = function( hex ){
		const rgb = rph.colorPicker.rgbFromHex( hex )
		return rph.colorPicker.hslFromRgb( rgb[0], rgb[1], rgb[2] )
	}
	rph.colorPicker.hslFromRgb = function( r, g, b ){
		r /= 255, g /= 255, b /= 255
		const max = Math.max( r, g, b ), min = Math.min( r, g, b )
		let h, s; const l = ( max + min ) / 2

		if( max === min ){
			h = s = 0 // achromatic
		} else {
			const d = max - min
			s = l > 0.5 ? d / ( 2 - max - min ) : d / ( max + min )

			switch ( max ){
				case r: h = ( g - b ) / d + ( g < b ? 6 : 0 ); break
				case g: h = ( b - r ) / d + 2; break
				case b: h = ( r - g ) / d + 4; break
			}

			h /= 6
		}
		return [Math.round( h * 360 ), Math.round( s * 100 ), Math.round( l * 100 )]
	}
	rph.colorPicker.rgbFromHsl = function( h, s, l ){
		let r, g, b

		h /= 60
		if( h < 0 ) h = 6 - ( -h % 6 )
		h %= 6

		s = Math.max( 0, Math.min( 1, s / 100 ) )
		l = Math.max( 0, Math.min( 1, l / 100 ) )

		const c = ( 1 - Math.abs( ( 2 * l ) - 1 ) ) * s,
			x = c * ( 1 - Math.abs( ( h % 2 ) - 1 ) )

		if( h < 1 ){
			r = c, g = x, b = 0
		} else if( h < 2 ){
			r = x, g = c, b = 0
		} else if( h < 3 ){
			r = 0, g = c, b = x
		} else if( h < 4 ){
			r = 0, g = x, b = c
		} else if( h < 5 ){
			r = x, g = 0, b = c
		} else {
			r = c, g = 0, b = x
		}
		const m = l - c / 2

		return [Math.round( ( r + m ) * 255 ), g = Math.round( ( g + m ) * 255 ), b = Math.round( ( b + m ) * 255 )]
	}
	rph.colorPicker.hexFromHsl = function( h, s, l ){
		const rgb = rph.colorPicker.rgbFromHsl( h, s, l )
		return rph.colorPicker.hexFromRgb( rgb[0], rgb[1], rgb[2] )
	}
	const normalize = ( val, max, min ) => {
		return ( val - min ) / ( max - min )
	}
	rph.colorPicker.refreshSwatch = function(){
		let hue = $( '#hue' ).slider( 'value' ),
			sat = $( '#saturation' ).slider( 'value' ),
			lum = $( '#luminosity' ).slider( 'value' )
		const satSoftCap = 40,
			satDefaultCap = 100,
			lumSoftFloor = 60,
			lumDefaultFloor = 40,
			satCapDiff = satDefaultCap - satSoftCap,
			lumCapDiff = lumDefaultFloor - lumSoftFloor,
			hueRanges = [
				[210, 360],
				[0, 15]
			]
		let inRange = false
		hueRanges.forEach( function( range, i ){
			const hueStart = range[0],
				hueEnd = range[1]
			if( hue > hueStart && hue < hueEnd ){ // dark colors
				inRange = true
			}
		})
		if( inRange ){
			const satDist = Math.min( 1, Math.max( 0, normalize( sat, satDefaultCap, satSoftCap ) ) ) // range within soft cap bounds
			let extra = 0
			if( hue > 230 && hue < 260 ){
				if( hue < 245 ){
					extra = normalize( hue, 245, 230 ) * 10
				} else {
					extra = normalize( hue, 245, 260 ) * 10
				}
			}
			$( '#luminosity' ).slider( 'option', 'min', lumDefaultFloor + ( ( lumSoftFloor - lumDefaultFloor ) * satDist ) + extra )
			$( '#bright-notification' ).css( 'visibility', 'visible' )
		} else {
			$( '#luminosity' ).slider( 'option', 'min', lumDefaultFloor )
			$( '#bright-notification' ).css( 'visibility', 'hidden' )
		}
		const lumDist = Math.max( 0, normalize( lum, lumDefaultFloor, lumSoftFloor ) )
		$( '#saturation' ).slider( 'option', 'min', 50 * lumDist )
		hue = $( '#hue' ).slider( 'value' ),
		sat = $( '#saturation' ).slider( 'value' ),
		lum = $( '#luminosity' ).slider( 'value' )

		const hex = rph.colorPicker.hexFromHsl( hue, sat, lum )
		$( '#swatch, .no-fade.name' ).css( 'color', '#' + hex )
		$( '#saturation' ).css( 'background', 'linear-gradient(90deg, hsla(' + hue + ', ' + $( '#saturation' ).slider( 'option', 'min' ) + '%, ' + lum + '%, 1), hsla(' + hue + ', 100%, ' + lum + '%, 1))' )
		$( '#luminosity' ).css( 'background', 'linear-gradient(90deg, hsla(' + hue + ', ' + sat + '%, ' + $( '#luminosity' ).slider( 'option', 'min' ) + '%, 1), hsla(' + hue + ', ' + sat + '%, 100%, 1))' )
		$( '#hue' ).find( '.ui-slider-handle' ).css( 'background', 'hsla(' + hue + ', 100%, 50%, 1)' )

		rph.colorPicker.hex = hex
		rph.colorPicker.$el.find( '#swatch .hexcolor' ).text( hex )
	}
	rph.colorPicker.send = function(){
		if( rph.colorPicker.colors === 2 ){
			rph.colorPicker.User.props.color = rph.colorPicker.User.props.color.slice( 0, 2 )
		}
		if( rph.colorPicker.User.props.fade === 0 ){
			rph.colorPicker.User.props.color[0] = rph.colorPicker.hex
			rph.colorPicker.User.props.color = rph.colorPicker.User.props.color.slice( 0, 1 )
		}
		const toSend = {
			userid: rph.colorPicker.User.props.id,
			color: rph.colorPicker.User.props.color,
			fade: rph.colorPicker.User.props.fade
		}
		socket.emit( 'modify', toSend )
		console.log( 'toSend modify', toSend )
	}
	rph.colorPicker.$el.find( '#hue, #saturation, #luminosity' ).each( function( ev ){
		const $this = $( this )
		$this.slider({
			orientation: 'horizontal',
			range: 'min',
			min: parseInt( $this.attr( 'min' ) ) || 0,
			max: parseInt( $this.attr( 'max' ) ) || 100,
			value: 20,
			slide: rph.colorPicker.refreshSwatch,
			change: rph.colorPicker.refreshSwatch
		})
	})
	rph.colorPicker.$el.find( 'button.submit' ).button().on( 'click', function(){
		console.log( 'click', rph.colorPicker.User.props.fade )
		rph.colorPicker.send()
		rph.colorPicker.hide()
	})

	const statusSetter = new rph.CustomDialog( 'Set Status',
		`<select class="status-type"><option>Basic</option><option>Busy</option></select>
			<input placeholder="20 characters maximum for free accounts; 100 for paid accounts" class="status-msg" />
			<div class="two-columns">
				<button class="premium">Make Permanent</button><button class="submit">Set Status</button>
			</div>`,
		{draggable: false, resizable: false, width: 485, height: 180})
	statusSetter.setUser = function( User ){
		this.User = User
		this.$el.find( 'input' ).val( this.User.props.statusMsg )
		this.$el.find( 'select' ).prop( 'selectedIndex', this.User.props.statusType )
		if( User.props.premium ){
			this.$el.find( '.premium' ).hide()
		} else {
			this.$el.find( '.premium' ).show()
		}
		User.$addEl( this.$el )

		return this
	}
	statusSetter.onClose( function(){
		if( statusSetter.User ){
			statusSetter.User.$removeEl( statusSetter.$el )
		}
	})
	statusSetter.send = function(){
		const msg = statusSetter.$el.find( '.status-msg' ).val(),
			type = statusSetter.$el.find( 'select' ).prop( 'selectedIndex' )
		console.log( 'modify', {userid: this.User.props.id, statusMsg: msg, statusType: type})
		socket.emit( 'modify', {userid: this.User.props.id, statusMsg: msg, statusType: type})
	}
	statusSetter.$el.find( 'button' ).button().filter( '.submit' ).on( 'click', function(){
		statusSetter.send()
	})
	statusSetter.$el.find( 'input' ).keydown( function( ev ){
		if( ev.keyCode === 13 ){
			statusSetter.send()
		}
	})

	const adSetter = new rph.CustomDialog( 'Set Looking for RP Advertisement',
		`<select class="status-type"><option>Story Driven</option><option>Sex Driven</option></select>
			<textarea placeholder="Maximum of 1000 characters long. Setting it to empty will remove the ad listing." autocomplete="off" />
			<div class="two-columns">
				<button class="premium">Make Permanent</button><button class="submit">Set LfRP Ad</button>
			</div>`,
		{draggable: false, resizable: false, width: 450, height: 180})
	adSetter.setUser = function( User ){
		this.User = User
		this.$el.find( 'textarea' ).val( this.User.props.lfrpAd )
		this.$el.find( 'select' ).prop( 'selectedIndex', this.User.props.lfrpAdType - 1 )
		if( User.props.premium ){
			this.$el.find( '.premium' ).hide()
		} else {
			this.$el.find( '.premium' ).show()
		}
		User.$addEl( this.$el )

		return this
	}
	adSetter.onClose( function(){
		if( adSetter.User ){
			adSetter.User.$removeEl( adSetter.$el )
			adSetter.User.$removeEl( statusSetter.$el )
		}
	})
	adSetter.send = function(){
		const msg = adSetter.$el.find( 'textarea' ).val(),
			type = adSetter.$el.find( 'select' ).prop( 'selectedIndex' ) + 1
		socket.emit( 'modify', {userid: this.User.props.id, lfrpAd: msg, lfrpAdType: type})
	}
	adSetter.$el.find( 'button' ).button().filter( '.submit' ).on( 'click', function(){
		adSetter.send()
	})

	const setPremium = new rph.CustomDialog( 'Upgrade a character',
		`<p>For $1, you can upgrade a character to "premium".<br>
			Permanent names get:<br>
			Status is saved between sessions<br/>
			LFRP ad is saved for easier reposting<br>
			LFRP ad is kept up about an hour after going offline<br>
			<br>
			Non-premium characters have their status messages and lfrp advertisements cleared on disconnect.</p>
			<ul class="users" />`,
		{resizable: false, width: 600, height: 440})
	setPremium.onOpen( function(){
		$( '<p style="width:140px;position:absolute;top:50%;line-height:30px;margin-top:-50px;">Choose character to send from:</p>' ).appendTo( this.$msgs )
		const $users = setPremium.$el.find( '.users' )
		$users.empty()
		account.userids.forEach( ( userid ) => {
			getUserById( userid, function( accountUser ){
				const $userSel = $( '<li><span class="name">' + accountUser.props.name + '</span></li>' ).prepend( accountUser.$createThumb() )

				if( accountUser.props.premium ){
					$( '<span class="no-upgrade">&nbsp;</span>' )
						.prependTo( $userSel )
				} else {
					$( '<a class="upgrade">Upgrade to Premium</a>' )
						.prependTo( $userSel )
				}
				$userSel.on( 'click', '.upgrade', function( ev ){
					socket.emit( 'make-premium', accountUser.props.id )
					$( this ).removeClass( 'upgrade' ).addClass( 'no-upgrade' ).html( '&nbsp;' )
				})

				$userSel.appendTo( $users )
			})
		})
	})
	$( '.premium' ).on( 'click', function(){
		setPremium.show()
	})

	const lfrpDialog = new rph.CustomDialog( 'Search for RP Ads, or Post Your Own',
		`<div id="kriegslistHeader" class="ui-corner-top">
												<p><span class="big">Kriegslist</span> - for finding RP.</p>
												<div class="tabs">
													<button class="type-1 active no-border-radius-bottom">Story Driven RP Adverts</button>
													<button class="type-2 no-border-radius-bottom">Sex Driven RP Adverts</button>
												</div>
											</div>
											<div id="lfrp-tabs">
												<div class="type-1" />
												<div class="type-2" style="display:none;" />
											</div>`,
		{width: 750, height: 550})
	lfrpDialog.setUser = function( User ){
		this.User = User
		return this
	}
	lfrpDialog.show = function(){
		const newPos = Math.round( Math.random() * 2 ) * 125
		this.$el.find( '#kriegslistHeader' ).css( 'background-position', '0 -' + newPos + 'px' )
		socket.emit( 'get-lfrp-ads' )
		this.$el.dialog( 'open' )
		return this
	}
	lfrpDialog.hide = function(){
		this.$el.dialog( 'close' )
		// socket.emit('unsub-lfrp');
		return this
	}
	lfrpDialog.callback = function(){}
	lfrpDialog.onComplete = function( callback ){
		this.callback = callback
	}
	lfrpDialog.complete = function(){
		this.callback()
		this.callback = function(){}
	}

	lfrpDialog.$el.find( 'button' ).button()
	lfrpDialog.$el.find( 'button.type-1, button.type-2' ).on( 'click', function(){
		const $this = $( this )
		if( $this.hasClass( 'type-1' ) ){
			$this.addClass( 'active' )
			lfrpDialog.$el.find( '#lfrp-tabs > *' ).hide()
			lfrpDialog.$el.find( '#lfrp-tabs .type-1' ).show()
		} else {
			$this.addClass( 'active' )
			lfrpDialog.$el.find( '#lfrp-tabs > *' ).hide()
			lfrpDialog.$el.find( '#lfrp-tabs .type-2' ).show()
		}
	})
	$( '.open-lfrp' ).on( 'click', function(){
		lfrpDialog.show()
	})
	socket.on( 'lfrp-ads', function( users ){
		const len = users.length
		let i = 0
		lfrpDialog.$el.find( 'div.type-1, div.type-2' ).empty()
		users.forEach( ( userid ) => {
			getUserById( userid, function( User ){
				i++
				// if( User.props.lfrpAdType === 1 )
				const $el = $( '<div class="lfrp-ad"><div class="user-box" /><div class="ad-box" /></div>' ).appendTo( lfrpDialog.$el.find( 'div.type-' + User.props.lfrpAdType ) )
				$el.find( '.user-box' ).append( User.$createEl().prepend( User.$createThumb() ) )
				$el.find( '.ad-box' ).append( '<p>' + parseMsg( User.props.lfrpAd ) + '</p>' )
				if( i === len ){
					lfrpDialog.complete()
				}
			})
		})
	})

	global.userContextMenu = function( $target, User, ev ){
		const html = `<div class="container" id="dropdownMenu">
					<ul class="inner smallBorders" style="padding: 2px;"></ul>
				</div>`,
			buttonhtml = '<li>Placeholder</li>',

			$menu = $( html ).appendTo( 'body' )
		$( 'body' ).on( 'mouseup.contextMenu', function( ev ){
			if( $menu.has( ev.target ).length === 0 ){
				$menu.remove()
				$( 'body' ).off( 'mouseup.contextMenu' )
			}
		})
		$menu.on( 'contextmenu', function( ev ){
			return false
		})

		const $profileButton = $( buttonhtml ).html( '<a href="//profiles.rphaven.com/' + User.props.name + '" target="_blank">View Profile</a>' )
			.on( 'click', function( ev ){
				ev.stopPropagation()
			})
			.appendTo( $menu.find( '.inner' ) )
		if( !User.blocked ){
			$( buttonhtml ).text( 'New PM' ).on( 'click', function( ev ){
				User.newPm()
			}).appendTo( $menu.find( '.inner' ) )
		}
		if( User.friendOf ){
			$( buttonhtml ).text( 'Unfriend' ).on( 'click', function( ev ){
				socket.emit( 'deny-friend-request', {from: User.friendOf.props.id, to: User.props.id})
			}).appendTo( $menu.find( '.inner' ) )
		}
		if( User.blocked ){
			$( buttonhtml ).text( 'Unblock' ).on( 'click', function( ev ){
				socket.emit( 'unblock', {id: User.props.id})
			}).appendTo( $menu.find( '.inner' ) )
		} else if( !User.friendOf && !accountFns.isOwnUser( account, User ) ){
			$( buttonhtml ).text( 'Block' ).on( 'click', function( ev ){
				socket.emit( 'block', {id: User.props.id})
			}).appendTo( $menu.find( '.inner' ) )
		}

		if( account.userids.includes( User.props.id ) ){
			$( '<li class="hr" />' ).appendTo( $menu.find( '.inner' ) )

			const $editButton = $( buttonhtml ).html( '<a href="//www.rphaven.com/account.php?edit=' + User.props.id + '" target="_blank">Edit Profile</a>' )
				.appendTo( $menu.find( '.inner' ) )
			$editButton.on( 'click', function(){
				$( this ).find( 'a' ).click()
			})

			if( account.props.sub ){
				$( buttonhtml ).text( 'Set Name' ).on( 'click', function( ev ){
					rph.PointerInput.attachTo( $( this ) ).prop( 'placeholder', 'New Vanity Name' ).onSubmit( function(){
						socket.emit( 'modify', {userid: User.props.id, vanity: this.val()})
					})
					ev.stopPropagation()
				}).appendTo( $menu.find( '.inner' ) )
			}

			$( buttonhtml ).text( 'Set Color' ).on( 'click', function( ev ){
				// Object.values(rph.dialogs).forEach( dialog => dialog.hide() )
				rph.dialogs['Set Color']
					.setUser( User )
					.show()
					.$el.dialog( 'widget' ).position({my: 'left center', at: 'right center', of: $menu, collision: 'flipfit'})
				ev.stopPropagation()
			}).appendTo( $menu.find( '.inner' ) )

			$( buttonhtml ).text( 'Set Badges' ).on( 'click', function( ev ){
				// Object.values(rph.dialogs).forEach( dialog => dialog.hide() )
				rph.dialogs['Set Badges']
					.show()
					.$el.dialog( 'widget' ).position({my: 'left center', at: 'right center', of: $menu, collision: 'flipfit'})
				badgeSetter.user = User
				rph.dialogs['Set Badges'].$el.parent().find( 'span.ui-dialog-title' ).html( 'Select badges to display for ' + User.props.name )
			}).appendTo( $menu.find( '.inner' ) )

			$( buttonhtml ).text( 'Set Status' ).on( 'click', function( ev ){
				// Object.values(rph.dialogs).forEach( dialog => dialog.hide() )
				console.log( 'open Set Status...', rph.dialogs['Set Status'] )
				rph.dialogs['Set Status']
					.setUser( User )
					.show()
					.$el.dialog( 'widget' ).position({my: 'left center', at: 'right center', of: $menu, collision: 'flipfit'})
				ev.stopPropagation()
			}).appendTo( $menu.find( '.inner' ) )

			$( buttonhtml ).text( 'Set LFRP Ad' ).on( 'click', function( ev ){
				// Object.values(rph.dialogs).forEach( dialog => dialog.hide() )
				rph.dialogs['Set Looking for RP Advertisement']
					.setUser( User )
					.show()
					.$el.dialog( 'widget' ).position({my: 'left center', at: 'right center', of: $menu, collision: 'flipfit'})
				ev.stopPropagation()
				// socket.emit('unblock', {'id':User.props.id});
			}).appendTo( $menu.find( '.inner' ) )
		} else {
			$( '<li class="hr" />' ).appendTo( $menu.find( '.inner' ) )
			if( $target.hasClass( 'hide-thumb' ) ){
				$( buttonhtml ).text( 'Show Thumbnail' ).on( 'click', function( ev ){
					User.els().forEach( ( $el ) => {
						$el.removeClass( 'hide-thumb' )
					})
				}).appendTo( $menu.find( '.inner' ) )
			} else {
				$( buttonhtml ).text( 'Hide Thumbnail' ).on( 'click', function( ev ){
					User.els().forEach( ( $el ) => {
						$el.addClass( 'hide-thumb' )
					})
				}).appendTo( $menu.find( '.inner' ) )
			}
		}
		if( $target.closest( '.room' )[0] ){
			const Room = getRoom( $target.closest( '.room' ).data( 'roomname' ) ),

				isOwner = isOwnerOf( Room ),
				isMod = isModOf( Room )

			if( isOwner ){
				$( '<li class="hr" />' ).appendTo( $menu.find( '.inner' ) )
				if( !isOwnerOf( Room, User ) ){
					$( buttonhtml ).text( '+ Co-owner' ).on( 'click', function( ev ){
						rph.UserSelector.attachTo( $( this ), function( byUser ){
							socket.emit( 'add-owner', {room: Room.props.name, userid: byUser.props.id, targetid: User.props.id, msg: ''})
						}, Room )
					}).appendTo( $menu.find( '.inner' ) )
				} else {
					$( buttonhtml ).text( '- Co-owner' ).on( 'click', function( ev ){
						rph.UserSelector.attachTo( $( this ), function( byUser ){
							socket.emit( 'remove-owner', {room: Room.props.name, userid: byUser.props.id, targetid: User.props.id, msg: ''})
						}, Room )
					}).appendTo( $menu.find( '.inner' ) )
				}
				if( !isOwnerOf( Room, User ) && !isModOf( Room, User ) ){
					$( buttonhtml ).text( '+ Moderator' ).on( 'click', function( ev ){
						rph.UserSelector.attachTo( $( this ), function( byUser ){
							console.log( 'add moderator', Room.props.name, byUser.props.id, User.props.id )
							socket.emit( 'add-mod', {room: Room.props.name, userid: byUser.props.id, targetid: User.props.id, msg: ''})
						}, Room )
					}).appendTo( $menu.find( '.inner' ) )
				} else if( isModOf( Room, User ) ){
					$( buttonhtml ).text( '- Moderator' ).on( 'click', function( ev ){
						rph.UserSelector.attachTo( $( this ), function( byUser ){
							socket.emit( 'remove-mod', {room: Room.props.name, userid: byUser.props.id, targetid: User.props.id, msg: ''})
						}, Room )
					}).appendTo( $menu.find( '.inner' ) )
				}
			}

			if( isOwner || isMod ){
				if( Room.props.bans.indexOf( User.props.id ) === -1 ){
					if( !isOwnerOf( Room, User ) ){
						$( '<li class="hr" />' ).appendTo( $menu.find( '.inner' ) )
						$( buttonhtml ).text( 'Kick' ).on( 'click', function( ev ){
							const $this = $( this )
							rph.UserSelector.attachTo( $this, function( byUser ){
								// socket.emit('kick', {room:Room.props.name, userid:byUser.props.id, targetid:User.props.id, msg:''});
								rph.PointerInput.attachTo( $target ).prop( 'placeholder', 'Kick reason' ).onSubmit( function(){
									socket.emit( 'kick', {room: Room.props.name, userid: byUser.props.id, targetid: User.props.id, msg: this.val()})
								})
							}, Room )
						}).appendTo( $menu.find( '.inner' ) )
					}
					if( !isOwnerOf( Room, User ) && !isModOf( Room, User ) ){
						$( buttonhtml ).text( 'Ban' ).on( 'click', function( ev ){
							const $this = $( this )
							rph.UserSelector.attachTo( $this, function( byUser ){
								rph.PointerInput.attachTo( $target ).prop( 'placeholder', 'Ban reason' ).onSubmit( function(){
									socket.emit( 'ban', {room: Room.props.name, userid: byUser.props.id, targetid: User.props.id, msg: this.val()})
								})
							}, Room )
						}).appendTo( $menu.find( '.inner' ) )
					}
				} else {
					$( '<li class="hr" />' ).appendTo( $menu.find( '.inner' ) )
					$( buttonhtml ).text( 'Unban' ).on( 'click', function( ev ){
						const $this = $( this )
						rph.UserSelector.attachTo( $menu, function( byUser ){
							rph.PointerInput.attachTo( $target ).prop( 'placeholder', 'Unban reason' ).onSubmit( function(){
								socket.emit( 'unban', {room: Room.props.name, userid: byUser.props.id, targetid: User.props.id, msg: this.val()})
							})
						}, Room )
					}).appendTo( $menu.find( '.inner' ) )
				}
			}
		}

		if( User.props.vanity ){
			$( '<p style="text-align:center;" class="small">a.k.a. ' + User.props.name + '</p>' )
				.appendTo( $menu.find( '.inner' ) )
		}

		$menu.on( 'click', 'li', function( ev ){
			$menu.remove()
		})

		$menu.position({my: 'right top', of: ev, collision: 'flip fit'})
		// $menu.position({ of: $(ev.target), my: 'center top', offset: '0 0' });
	}

	const user$els = {},
		users = messenger.users,
		usernames = [],
		userids = []

	global.user$els = user$els

	function User( args ){
		// const { props, priv } = args;
		const props = args.props
		if( userCache.has( props.id ) ){
			return userCache.get( props.id )
		}
		/*if( users[args.props.id] !== 'undefined' ){
			return users[args.props.id]
		}*/
		if( typeof props.color === 'string' ){ // make a more permanent fix to this soon. Why are these becoming strings?
			props.color = JSON.parse( props.color )
		}
		const user = this

		this.props = props || {}
		if( args.priv ){
			this.priv = args.priv
		}
		// this.$els = [];
		user$els[this] = []
		// this.lastUploadEpoch = 0

		Object.defineProperty( this, 'friendOf', {
			get: () => {
				const friendOf = account.users.find( ( user ) => {
					return user.priv.friends && user.priv.friends.includes( this.props.id )
				})
				return friendOf || false
			}
		})

		users[this.props.id] = reactive( this )
		const lowercaseName = this.props.name.toLowerCase()
		userids[lowercaseName] = this.props.id
		usernames[this.props.id] = lowercaseName

		return reactive( this )
	}
	User.prototype.els = function(){
		return user$els[this]
	}
	User.prototype.newPm = function(){
		const pm = new Pm( this )
		pm.selectFrom()
		pm.setActive()
		return pm
	}
	User.prototype.$addEl = function( $el ){
		user$els[this].push( $el )
	}
	User.prototype.$removeEl = function( $el ){
		const thisElIndex = user$els[this].indexOf( $el )
		user$els[this].splice( thisElIndex, 1 )
		$el.remove()
	}
	User.prototype.modify = function( data, debug ){
		const user = this

		if( typeof data !== 'undefined' ){
			for( const [key, value] of Object.entries( data ) ){
				user.props[key] = value
			}
			if( data.vanity || data.premium ){
				for( const [key, value] of Object.entries( data ) ){
					user.els().forEach( ( $el ) => {
						if( key === 'vanity' ){
							$el.find( '.name' ).text( value )
						} else if( key === 'premium' && value === 1 ){
							$el.find( '.premium' ).hide()
						}
					})
					user.props[key] = value
				}
			}

			user.els().forEach( ( $el ) => {
				if( data.iconExt ){
					$el.filterFind( 'img' ).attr( 'src', '//img.rphaven.com/th' + user.props.id + '.webp?' + Date.now() ) // add ?lastUpdatedDate or better yet make AWS clear the cache on update...
				}
			})
		}
		user.els().forEach( ( $el ) => {
			if( $el.find( '.name' ).length > 0 ){
				if( Array.isArray( user.props.color ) ){
					user.props.color.forEach( ( hex, i ) => {
						$el.find( '.name' ).get( 0 ).style.setProperty( '--color' + ( i + 1 ), '#' + user.props.color[i] )
					})
				}
			}
			$el.find( '.name' ).removeClass( 'vertical-fade horizontal-fade radial-fade' )
			if( user.props.fade ){
				if( user.props.fade === 1 ){
					$el.find( '.name' ).addClass( 'vertical-fade' )
				} else if( user.props.fade === 2 ){
					$el.find( '.name' ).addClass( 'horizontal-fade' )
				} else if( user.props.fade === 3 ){
					$el.find( '.name' ).addClass( 'radial-fade' )
				}
			}
			if( user.props.color.length > 1 ){
				let numColorClass = '-color'
				if( user.props.color.length === 2 ){
					numColorClass = 'two' + numColorClass
				} else {
					numColorClass = 'three' + numColorClass
				}
				$el.find( '.name' ).addClass( numColorClass )
			} else {
				$el.find( '.name' ).removeClass( 'two-color three-color' )
			}
		})
	}
	User.prototype.$createEl = function(){
		const thisUser = this,
			$el = $( '<div class="user offline user-' + thisUser.props.id + `">
				<div>
						<a class="name" style="--color1:#` + this.props.color[0] + '" data-name="' + this.props.name + '" data-content="' + ( this.props.vanity || this.props.name ) + '">' + ( this.props.vanity || this.props.name ) + `</a>
						<p class="statuses">
							<span class="icon owner" title="Room Owner" /><span class="icon mod" title="Room Moderator" />
							<span class="icon busy" title="Busy" /><span class="icon lfrp" title="Looking for RP" />
							<span class="statusMsg" />
						</p>
					</div>
				</div>` )

		$el.data( 'User', this )
		this.$addEl( $el )
		this.modify()

		return $el
	}
	$( '#friends-list, #profileHeader-name, #search-for-rp-ads002c-or-post-your-own-dialog' ).on( 'click', '.user a.name', function( ev ){
		ev.preventDefault()
		const $this = $( this ),
			userid = parseInt(
				$this.attr( 'class' )
					.split( ' ' )
					.find( ( className ) => className.includes( 'user-' ) )
					.slice( 5 )
			)
		getUserById( userid, function( User ){
			if( User.friendOf && $this.closest( '.user' ).find( '.friend-of' )[0] ){
				const ofUserid = parseInt(
					$this.closest( '.user' ).find( '.friend-of' ).attr( 'class' )
						.split( ' ' )
						.find( ( className ) => className.includes( 'user-' ) )
						.slice( 5 )
				)
				//ofUserName = ofUserName.slice( ofUserName.indexOf( ':' ) + 2 )
				getUserById( ofUserid, ( ofUser ) => {
					rph.getPm({from: ofUser.props.id, to: User.props.id}, function( pm ){
						pm.setActive()
					})
				})
			} else {
				User.newPm()
			}
		})
	})
	$( '#chat, #chatters' ).on( 'click', 'a.name', function( ev ){
		const userid = parseInt(
			$( this ).attr( 'class' )
				.split( ' ' )
				.find( ( className ) => className.includes( 'user-' ) )
				.slice( 5 )
		)
		getUserById( userid, ( User ) => {
			User.newPm()
		})
	})
	$( 'body' ).on( 'contextmenu', 'a.name', function( ev ){
		// console.log('body on contextmenu');
		ev.preventDefault()
		const $this = $( this ),
			userid = parseInt(
				$this.attr( 'class' )
					.split( ' ' )
					.find( ( className ) => className.includes( 'user-' ) )
					.slice( 5 )
			)
		getUserById( userid, ( User ) => {
			userContextMenu( $this, User, ev )
		})
	})
	User.prototype.$createImg = function(){
		if( this.props.animateIcon !== null ){
			return $( '<picture><img src="//img.rphaven.com/th' + this.props.id + '.webp" /></picture>' )
		} else {
			return $( '<picture><img src="//img.rphaven.com/th_noimage.png" /></picture>' )
		}
	}
	User.prototype.$createThumb = function(){
		return this.$createImg().addClass( 'thumb' )
	}
	User.prototype.openProfile = function(){
		window.open( '//profiles.rphaven.com/' + this.props.name )
	}
	User.prototype.setFriend = function( ofUser ){
		const user = this
		user.modify()
	}
	User.prototype.block = function(){
		socket.emit( 'block', {id: this.props.id})
	}
	User.prototype.setBlocked = function(){
		this.blocked = true
	}
	User.prototype.rmBlocked = function(){
		delete this.blocked

		const foundi = account.ignores.indexOf( this.props.id )
		account.ignores.splice( foundi, foundi !== -1 ) // remove if exists
	}
	socket.on( 'remove-ignore', function( data ){
		getUserById( data.id, function( user ){
			user.rmBlocked()
		})
	})
	User.prototype.showInvite = function( ofUser ){
		const fromUser = this
		this.$invites = this.$invites ? this.$invites : {}
		if( !$topBtns.find( '.name:contains("' + fromUser.props.name + '")' )[0] ){
			const $el = $( '<div class="friend-invite"><p><span class="name" data-name="' + fromUser.props.name + '">' + ( fromUser.props.vanity || fromUser.props.name ) + '</span> wants to befriend ' + ofUser.props.name + '</p></div>' ).appendTo( $topBtns )
			$( '<a>Accept</a>' ).on( 'click', function( ev ){
				socket.emit( 'accept-friend-request', {from: ofUser.props.id, to: fromUser.props.id})
			}).appendTo( $el )
			$( '<a class="right">Deny</a>' ).on( 'click', function( ev ){
				socket.emit( 'deny-friend-request', {from: ofUser.props.id, to: fromUser.props.id})
			}).appendTo( $el )
			this.$invites[ofUser.props.id] = $el
		}
	}
	socket.on( 'remove-friend-request', function( data ){
		getUserById( data.id, function( user ){
			getUserById( data.ofid, function( ofUser ){
				// console.log(ofUser.$invites, data);
				user.removeInvite( ofUser )
			})
		})
	})
	User.prototype.removeInvite = function( ofUser ){
		if( this.$invites && this.$invites[ofUser.props.id] ){
			const $el = this.$invites[ofUser.props.id]
			$el.remove()
			delete this.$invites[ofUser.props.id]
		}
	}

	$( '#userlist' ).on( 'mouseenter', '.user', function( ev ){
	}).on( 'mouseleave', '.user', ( ev ) => { // hide if user-line or miniprofile isn't hovered
		/*const $miniProfile = $( '#mini-profile' )
		if( $.contains( $miniProfile[0], ev.relatedTarget ) ){
			$miniProfile.one( 'mouseleave', () => {
				$miniProfile.hide()
			})
		} else {
			$miniProfile.hide()
		}*/
	})

	$( `<div id="slider-ingrediants" class="dark-bg absolute" data-animation="flip-in" data-state="hidden" style="display:none;">
			<ul>
				<li class="clickable" id="edit">Edit</li>
				<li class="clickable" id="roll">Dice Roll</li>
			</ul>
		</div>` ).appendTo( 'body' )
	$( 'body' ).on( 'click', function( ev ){
		$( '#slider-ingrediants' ).hide().attr( 'data-state', 'hidden' )
		$( '#edit, #roll' ).off()
	})

	rph.badgeSetter = new rph.CustomDialog( 'Set Badges',
		`<div>
			<badge-setter :user="user">
		</div>`,
		{draggable: false, resizable: false, width: 440, height: 380}
	)
	const badgeSetter = createVue({
		data: () => ({
			user: false
		}),
		components: {
			badgeSetter: BadgeSetterVue
		}
	})
		.mount( rph.badgeSetter.$el[0] )
	$( '#set-badges-dialog' )[0].Vue = badgeSetter

	rph.diceRollerDialog = new rph.CustomDialog( 'Roll Dice',
		`<div>
			<message-roller :account="account" :msgid="msgid" :toid="toid" :userid="userid" :roomname="roomname" />
		</div>`,
		{draggable: false, resizable: false, width: 440, height: 230}
	)

	const diceRollerVue = createVue({
		data: () => ({
			account: account,
			msgid: 0,
			toid: 0,
			userid: 0,
			roomname: ''
		}),
		components: {
			messageRoller: MessageRollerVue
		}
	})
		.mount( rph.diceRollerDialog.$el[0] )

	global.bindSliderMenu = function( $container, roomname, toid, userid ){ // because this binds to the whole message window for efficiency, can't stop those vars permanently
		$container.on( 'click', '.slider', function( ev ){
			const $this = $( this ),
				$popup = $( '#slider-ingrediants' ),
				$line = $this.closest( '.message-line' ),
				msgid = parseInt( $line.find( '.timestamp' ).attr( 'data-unixtime' ) )
			userid = parseInt( $line.find( '.timestamp' ).attr( 'data-userid' ) )

			var popper = createPopper( $this[0], $popup[0], {
				placement: 'top'
			})
			$popup.show().attr( 'data-state', 'visible' )

			ev.stopPropagation()
			if( $line.has( '.roll-result' ).length ){
				$popup.find( '.clickable' ).addClass( 'disabled' )
			} else {
				$popup.find( '.clickable' ).removeClass( 'disabled' )
				$( '#edit' ).on( 'click', function( ev ){
					const removeEditable = () => {
							$line.find( '.message' ).attr( 'contenteditable', 'false' )
								.removeClass( 'editing' )
							$line.find( '.edit-controls' ).remove()
							$line.find( '.message' ).html( parseMsg( $line.find( '.message' ).attr( 'data-unparsed' ) ) )
							$line.find( '.message-right' ).attr( 'style', '' ) // remove .show() without overriding hover...
						},
						submitEdit = () => {
							const newMsg = $line.find( '.message' ).html().replace( /\<br\>/g, '\n' )
							removeEditable()
							socket.emit( 'edit', {newMsg: newMsg, roomname: roomname, msgid: msgid, toid: toid, userid: userid})
						},
						cancelEdit = () => {
							removeEditable()
						}

					$line.find( '.message' )
						.html( unquoteAttr( $line.find( '.message' ).attr( 'data-unparsed' ) ).replace( /\n/g, '<br>' ) )
						.attr( 'contenteditable', 'true' )
						.addClass( 'editing' )
						.focus()
					$line.find( '.message-right' ).show()

					$( '<div class="edit-controls"><a class="cancel">cancel</a>(esc) | <a class="submit">save</a>(enter)</div>' )
						.appendTo( $line.find( '.message-right' ) )
					$line.find( '.cancel' ).on( 'click', () => {
						cancelEdit()
					})
					$line.find( '.submit' ).on( 'click', () => {
						submitEdit()
					})
					$line.find( '.message' ).off().on( 'keydown', function( ev ){
						console.log( 'ev.keyCode', ev.keyCode )
						if( ev.keyCode === 13 && !( ev.ctrlKey || ev.shiftKey ) ){ // ignore if holding shift or control
							submitEdit()
						} else if( ev.keyCode === 27 ){
							cancelEdit()
						}
					})
				})
				$( '#roll' ).on( 'click', function( ev ){
					diceRollerVue.msgid = msgid
					diceRollerVue.userid = userid || 0
					diceRollerVue.toid = toid || 0
					diceRollerVue.roomname = roomname || false
					rph.diceRollerDialog.show().$el.dialog( 'widget' ).position({my: 'left bottom', at: 'right center', of: ev, collision: 'flipfit'})
				})
			}
		})
	}

	const canvas = document.createElement( 'canvas' ),
		$favicon = $( '<link type="image/x-icon" rel="shortcut icon" >' ).appendTo( 'head' )
	canvas.width = 64
	canvas.height = 64
	global.drawIcon = function( count ){
		const white = '#FFFFFF',
			red = '#F00'
		if( typeof canvas.getContext === 'function' ){
			const ctx = canvas.getContext( '2d' ),
				img = new Image()
			img.width = 64
			img.height = 64
			img.src = '/favicon.ico'
			img.onload = function(){
				ctx.drawImage( img, 0, 0, 64, 64 )
				ctx.fillStyle = red
				ctx.font = '36px Calibri'

				if( rph.alerted ){
					ctx.fillRect( 0, 0, 64, 64 )
					ctx.fillStyle = white
					ctx.fillText( 'AHH', 2, 31 )
					ctx.fillText( 'HHH', 1, 59 )
					setTimeout( function(){
						rph.alerted = false
						drawIcon()
					}, 4000 )
				} else {
					if( rph.pinged ){
						ctx.fillRect( 10, 31, 24, 30 )
						ctx.fillStyle = white
						ctx.fillText( '!', 16, 59 )
					}
					if( rph.unreadPms ){
						const unread = rph.unreadPms > 9 ? 9 : rph.unreadPms
						ctx.fillStyle = red
						ctx.fillRect( 37, 31, 24, 30 )
						ctx.fillStyle = white
						ctx.fillText( unread, 40, 59 )
						if( rph.unreadPms > 9 ){
							ctx.fillText( '+', 50, 59 )
						}
					}
				}

				$favicon.attr( 'href', canvas.toDataURL( 'image/x-icon' ) )
			}
		}
	}

	$.widget( 'ui.dialog', $.extend({}, $.ui.dialog.prototype, { // make titles html, not text
		_title: function( title ){
			var $title = this.options.title || '&nbsp;'
			title.html( $title )
		}
	}) )
	const $pmDialog = $( `<div id="pm-dialog" title="RPHaven Private Messenger">
						<div>
							<div id="pm-top" class="border-box" />
							<div id="pm-bottom">
								<div class="inner">
									<div class="textarea" />
									<div class="ul-rows" />
								</div>
							</div>
						</div>
					</div>` )
			.dialog({
				autoOpen: false,
				width: account.settings.pmSize.width,
				height: account.settings.pmSize.height,
				position: [account.settings.pmPosition.left, account.settings.pmPosition.top],
				open: () => {
					$( '#pm-dialog' ).find( 'textarea:visible' ).focus()
				},
				dragStop: ( ev, ui ) => {
					account.settings.set( 'pmPosition', {top: ui.position.top, left: ui.position.left})
				},
				resizeStop: ( ev, ui ) => {
					account.settings.set( 'pmSize', {width: ui.size.width, height: ui.size.height})
				}
			}),
		$pmHeader = $( '<div id="pm-header" />' ).appendTo( $pmDialog.closest( '.ui-dialog' ).find( '.ui-dialog-titlebar' ) ),
		$pmTop = $pmDialog.find( '#pm-top' ),
		$pmTabRows = {}
	$pmTabRows.none = $( '<ul class="pm-tabs" />' ).appendTo( $pmDialog.find( '.ul-rows' ) ).sortable({
		placeholder: 'ui-state-highlight'
	})
	$pmDialog.closest( '.ui-dialog' ).find( '.ui-dialog-title' ).css({position: 'absolute', left: '4.15em', color: '#efefef', 'padding-left': '0'})
	$pmDialog.closest( '.ui-dialog' ).find( '.ui-dialog-titlebar' ).css({margin: 0, background: 'none'})
	$pmDialog.closest( '.ui-dialog' ).find( '.ui-icon-closethick' ).removeClass( 'ui-icon-closethick' ).addClass( 'ui-icon-minusthick' )
	$pmDialog.closest( '.ui-dialog' ).find( '.ui-dialog-titlebar-close' ).css({margin: '2px 2px 0 0', top: 'auto'})
	$pmDialog.activePm = null
	rph.pms = {}

	$pmDialog.on( 'dialogopen', () => {
		if( $pmDialog.activePm ){
			$pmDialog.activePm.setRead( 'dialogopen' )
		}
	})

	const pmsLength = () => {
		return Object.keys( rph.pms ).length
	}
	$( '<a class="button right" title="New PM Tab" style="position:absolute; bottom:6px; right:6px; line-height: 100%; padding:2px 5px 5px">+</a>' ).on( 'click', function( ev ){
		rph.PointerInput.attachTo( $( this ) ).onSubmit( function(){
			getUserByName( this.val(), ( user ) => {
				const pm = user.newPm()
			})
		})
	}).appendTo( $pmDialog.find( '#pm-bottom > .inner' ) )
	$msgsBtn.on( 'click', function( ev ){
		if( $pmDialog.dialog( 'isOpen' ) ){
			$pmDialog.dialog( 'close' )
		} else {
			$pmDialog.dialog( 'open' )
		}
	})

	function Pm( user, silent ){
		if( activeWindow || !silent ){
			$pmDialog.dialog( 'open' )
		}
		const pm = this
		this.title = 'Opening conversation to ' + ( user.props.vanity || user.props.name )
		this.to = user
		this.from = false
		this.unread = false

		this.$tab = $( '<li class="tab"><a class="name">' + ( user.props.vanity || user.props.name ) + '</a></li>' ).prepend( this.to.$createThumb() ).appendTo( $pmTabRows.none )
		this.$tab.on( 'click', function( ev ){
			pm.setActive()
		})
		this.$textarea = $( '<div class="textarea" autocomplete="off" />' ).hide().prependTo( $pmDialog.find( '#pm-bottom .inner' ) )
		this.$msgs = $( '<div class="msgs"></div>' ).hide().appendTo( $pmTop )
		this.$header = $( '<div class="header"><div class="top"><div class="right" /></div></div>' ).hide().prependTo( $pmHeader )
		this.$cornerThumb = $( '<div class="pm-thumb-corner"><user-state :user="user"></div>' ).prependTo( this.$header )

		this.$cornerThumb.prepend( this.to.$createThumb() )
		this.to.modify()

		createVue({
			data: () => ({
				user
			}),
			components: {
				UserState
			}
		})
			.mount( this.$cornerThumb[0] )

		$( '<a class="button" href="//profiles.rphaven.com/' + pm.to.props.name + '" target="_blank">View Profile</a>' )
			.insertAfter( this.$header.find( '.right' ) )

		if( !user.friendOf && !accountFns.isOwnUser( account, user ) ){
			$( '<a class="button">Block</a>' ).on( 'click', function( ev ){
				user.block()
			}).appendTo( this.$header.find( '.top .right' ) )
		}
		$( '<a title="Close this tab" class="button">Close tab</a>' ).on( 'click', function( ev ){
			pm.close()
		}).appendTo( this.$header.find( '.top .right' ) )

		if( pmsLength() === 0 ){
			this.setActive()
		}

		return this
	}
	function updatePmsSession(){
		const toSave = []
		for( const [key, pm] of Object.entries( rph.pms ) ){
			const pmRaw = {from: pm.from.props.id, to: pm.to.props.id}
			if( pm.unread ){
				pmRaw.unread = true
			}
			toSave.push( pmRaw )
		}
		account.settings.set( 'pms', toSave ) // why did this have a delay before?
	}
	Pm.prototype.close = function(){
		const $tabRow = this.$tab.parent()
		this.$header.remove()
		this.$msgs.remove()
		this.$textarea.remove()
		this.$tab.remove()
		if( this.from ){
			delete rph.pms[this.arrayKey]
			updatePmsSession()
		}

		if( this.from && $pmTabRows[this.from.props.id].children().length === 1 ){
			$pmTabRows[this.from.props.id].remove()
			delete $pmTabRows[this.from.props.id]
		}

		if( !$tabRow.children( '.tab' )[0] ){
			$tabRow.remove()
		}

		$pmDialog.activePm = null

		delete this
		$pmDialog.find( '.tab:eq(0)' ).click()
	}
	Pm.prototype.setActive = function(){
		$pmDialog.dialog( 'option', 'title', this.title )
		$pmDialog.closest( '.ui-dialog' ).find( '.header' ).hide()
		$pmDialog.find( '.msgs' ).hide()
		$pmDialog.find( '.textarea' ).hide()
		$pmDialog.find( '.tab' ).removeClass( 'active' )
		this.$header.show()
		this.$msgs.show()
		this.$textarea.show()
		this.$textarea.find( 'textarea' ).focus()
		this.$tab.addClass( 'active' )
		this.$textarea.find( 'textarea' ).focus()
		if( this.from ){
			this.setRead( 'setActive' )
		}

		if( this.$tab.parent().index() !== 0 ){
			$( '.pm-tabs:eq(0)' ).appendTo( $pmDialog.find( '.ul-rows' ) )
			this.$tab.parent().prependTo( $pmDialog.find( '.ul-rows' ) )
		}

		$pmTop.scrollTop( $pmTop[0].scrollHeight )

		$pmDialog.activePm = this
	}
	Pm.prototype.setUnread = function(){
		// console.log( 'setUnread', this )
		this.$tab.addClass( 'highlight' )
		this.unread = true

		rph.unreadPms = Object.values( rph.pms ).map( ( pm ) => +pm.unread ).reduce( ( total, toAdd ) => total + toAdd ) // +true / +false to implicit cast bitwise op
		drawIcon()
		$msgsBtn.find( '.notifications .num' ).text( rph.unreadPms ).show()

		updatePmsSession()
	}
	Pm.prototype.setRead = function( src ){
		if( !$pmDialog.dialog( 'isOpen' ) || this.unread === false ){
			return false
		}

		this.$tab.removeClass( 'highlight' )
		this.unread = false

		rph.unreadPms = Object.values( rph.pms ).map( ( pm ) => +pm.unread ).reduce( ( total, toAdd ) => total + toAdd )
		drawIcon()
		$msgsBtn.find( '.notifications .num' ).text( rph.unreadPms )
		if( rph.unreadPms === 0 ){
			$msgsBtn.find( '.notifications .num' ).hide()
		}

		updatePmsSession()
	}
	Pm.prototype.selectFrom = function( user ){
		this.setActive()
		const pm = this
		$( '<p style="width:140px;position:absolute;top:50%;line-height:30px;margin-top:-50px;">Choose character to send from:</p>' ).appendTo( this.$msgs )
		const $users = $( '<ul style="margin-left:160px;" class="user-selector" />' ).appendTo( this.$msgs ),
			$favUsers = $( '<ul style="margin-left:160px;" class="user-selector" />' ).appendTo( this.$msgs )
		account.userids.forEach( ( userid ) => {
			getUserById( userid, function( accountUser ){
				const $userSel = $( '<li><a class="username">' + ( accountUser.props.vanity || accountUser.props.name ) + '</a></li>' ).prepend( accountUser.$createThumb() ),

					$favBtn = $( '<a class="fav">&nbsp;<span class="tip">Set profile as a favorite, pinning it to the bottom of this list</span></a>' ),
					$favedBtn = $( '<a class="faved">&nbsp;<span class="tip">Remove from favorites</span></a>' ),
					addFav = function(){
						account.settings.favUsers.push( accountUser.props.id )
						account.settings.set( 'favUsers', account.settings.favUsers )
					},
					rmFav = function(){
						const foundi = account.settings.favUsers.indexOf( accountUser.props.id )
						account.settings.favUsers.splice( foundi, foundi !== -1 )
						account.settings.set( 'favUsers', account.settings.favUsers )
					}
				$userSel.on( 'click', '.fav', function( ev ){
					$userSel.find( '.fav' ).remove()
					$favedBtn.prependTo( $userSel )
					addFav()
				})
				$userSel.on( 'click', '.faved', function( ev ){
					$userSel.find( '.faved' ).remove()
					$favBtn.prependTo( $userSel )
					rmFav()
				})

				if( !account.settings.favUsers.includes( accountUser.props.id ) ){
					$userSel.appendTo( $users )
					// alphabetical insert
					$users.find( 'li' ).each( function(){
						const $this = $( this )
						if( ( accountUser.props.vanity || accountUser.props.name ) < $this.find( '.username' ).text() ){
							$userSel.insertBefore( $this )
							return false
						}
					})
					$favBtn.prependTo( $userSel )
				} else {
					$userSel.appendTo( $favUsers )
					$favedBtn.prependTo( $userSel )
				}

				$userSel.find( 'img, .username' ).on( 'click', function( ev ){
					pm.setFrom( accountUser )
					pm.setActive()
				})
			})
		})
	}
	Pm.prototype.setFrom = function( user ){
		const pm = this
		this.from = user

		bindSliderMenu( this.$msgs, false, pm.to.props.id, pm.from.props.id )

		const curPm = rph.getPmIfExists({to: pm.to.props.id, from: pm.from.props.id})
		if( curPm ){
			// console.log('previous:', curPm, 'new:', pm);
			curPm.setActive()
			pm.close()
		} else {
			if( this.to.friendOf !== this.from ){
				$( '<a class="button">Add Friend</a>' ).on( 'click', function( ev ){
					socket.emit( 'friend-request', {from: pm.from.props.id, to: pm.to.props.id})
				}).appendTo( this.$header.find( '.top' ) )
			}

			this.title = '' + ( pm.to.props.vanity || pm.to.props.name ) + ( pm.to.props.vanity ? ' <span class="small">a.k.a. ' + pm.to.props.name + '</span>' : '' ) + ' & ' + ( pm.from.props.vanity || pm.from.props.name ) + ( pm.from.props.vanity ? ' <span class="small">a.k.a. ' + pm.from.props.name + '</span>' : '' )
			this.$msgs.empty()

			this.arrayKey = 'from' + this.from.props.id + 'to' + this.to.props.id
			rph.pms[this.arrayKey] = this

			if( !$pmTabRows[this.from.props.id] ){
				$pmTabRows[this.from.props.id] = $( '<ul class="pm-tabs"><div class="right" /></ul>' ).appendTo( $pmDialog.find( '.ul-rows' ) ).sortable({
					placeholder: 'ui-state-highlight'
				})
				$pmTabRows[this.from.props.id].find( 'div' ).append( this.from.$createThumb() )

				if( $pmDialog.find( '.pm-tabs:eq(0)' ).is( $pmTabRows.none ) ){
					$pmTabRows.none.appendTo( $pmDialog.find( '.ul-rows' ) )
				}
			}
			this.$tab.appendTo( $pmTabRows[this.from.props.id] )

			let lastCaretPos = 99
			const getCursorPosition = ( el ) => {
				let pos = 0
				if( 'selectionStart' in el ){
					pos = el.selectionStart
				} else if( 'selection' in document ){
					el.focus()
					const Sel = document.selection.createRange(),
						SelLength = document.selection.createRange().text.length
					Sel.moveStart( 'character', -el.value.length )
					pos = Sel.text.length - SelLength
				}
				lastCaretPos = pos
			}

			$( '<textarea autocomplete="off" />' ).on( 'keydown', function( ev ){
				const key = ev.keyCode || ev.which

				if( !( ev.ctrlKey || ev.shiftKey ) && key === 9 ){
					console.log( 'ev.keyCode', key, ev )
					// $pmDialog.find('.tab:eq(0)').click();
					ev.preventDefault()
					const $curRow = pm.$tab.parent(),
						curTabIndex = $curRow.find( '.tab' ).index( pm.$tab )
					if( curTabIndex !== ( $curRow.find( '.tab' ).length - 1 ) ){
						$curRow.find( '.tab:eq(' + ( curTabIndex + 1 ) + ')' ).click()
					} else {
						$( '.pm-tabs:not(:empty):eq(1)' ).children( '.tab:first' ).click()
					}
					return false
				}
				if( key === 13 ){
					ev.preventDefault()
					const $this = $( this )
					if( !connected ){
						pm.appendMsg( '<p>You are not connected to the messenger server so your message can not be sent.  If it says it\'s reconnected in the bottom left, wait for it to reconnect or try clicking the manually reconnect button.  If neither of those work, try refreshing the page.</p>' )
						return
					}
					if( ev.ctrlKey || ev.shiftKey ){
						$this.insertAtCaret( '\n' )
						return
					}
					if( $this.val() !== '' ){
						socket.emit( 'pm', {from: pm.from.props.id, to: pm.to.props.id, msg: $this.val(), target: 'all', date: Date.now()})
						$this.val( '' )
					}
					idleEnd()
					idle = false
				} else if( ev.keyCode === 38 ){
					getCursorPosition( this )
					console.log( 'up key hit...', lastCaretPos )
					if( lastCaretPos === 0 ){
						console.log( 'cursor is stuck up top. Should edit' )
						pm.$msgs.find( '.message-line:has(.slider):gt(-10)' ).last().find( '.slider' ).click()
						$( '#edit' ).click()
					}
				}
			}).appendTo( this.$textarea )
			this.$textarea.typing({
				start: function( event, $elem ){
					socket.emit( 'typing-start', {from: pm.from.props.id, to: pm.to.props.id})
				},
				stop: function( event, $elem ){
					socket.emit( 'typing-end', {from: pm.from.props.id, to: pm.to.props.id})
				},
				delay: 5000
			})

			updatePmsSession()

			let lastHistoryDate,
				totalHistory = 0,
				fullHistoryCount = 0

			const appendHistory = function( row ){
				let classes = ''
				const message = parseMsg( row.msg )
				let me = false
				if( row.msg.charAt( 0 ) === '/' ){
					if( row.msg.toLowerCase().indexOf( 'me' ) === 1 ){
						me = true
						classes += 'action '
					}
				}
				rph.getPm({from: row.userid, to: row.otherid}, function( pm ){
					getUserById( row.fromid, function( fromUser ){
						const $el = pm.prependMsg( '<div class="message-right" /><p><span class="timestamp" data-unixtime="' + row.date + '" data-userid="' + fromUser.props.id + '">' + makeTimestamp( row.date ) + '</span><strong class="name">&nbsp;' + decodeURIComponent( fromUser.props.vanity || fromUser.props.name ) + ( me ? '' : '&nbsp;' ) + '</strong><span class="message" data-unparsed="' + quoteAttr( row.msg ) + '">' + message + '</span></p>' )
							.addClass( classes )

						if( accountFns.isOwnUser( account, fromUser.props.id ) ){ // doesn't work when these load before loading accoun
							$el.find( '.message-right' ).append( '<a class="slider">⋮</a>' )
						}
						if( row.roll ){
							appendRollResult( $el.find( '.message' ), row.roll, row.animate )
						}
						if( row.newMsg ){
							editMessage( $el.find( '.message' ), row.newMsg, row.editDate )
						}
					})
				})
				lastHistoryDate = row.date
				totalHistory += 1
			}

			db.msgs.where({userid: pm.from.props.id, otherid: pm.to.props.id})
				.reverse()
			// .sortBy('date')
				.limit( 10 )
				.toArray()
				.then( ( rows ) => {
					if( rows.length > 0 ){
						$( '<p class="ui-state-highlight ui-corner-all"><span class="ui-icon ui-icon-info" style="float: left; margin-right: .3em;"></span>Above is your previous message history</p>' )
							.prependTo( pm.$msgs )
					}
					rows.forEach( ( row ) => {
						appendHistory( row )
					})
					db.msgs.where({userid: pm.from.props.id, otherid: pm.to.props.id}).count()
						.then( ( count ) => {
							if( count > 10 ){
								$( '<p class="ui-state-highlight ui-corner-all top-response" style="margin-top:40px;"><span class="ui-icon ui-icon-info" style="float: left; margin-right: .3em;"></span>Scroll up to load more history</p>' )
									.prependTo( pm.$msgs )
							} else {
								$( '<p class="ui-state-highlight ui-corner-all top-response" style="margin-top:40px;"><span class="ui-icon ui-icon-info" style="float: left; margin-right: .3em;"></span>This is the beginning of your message history with ' + pm.to.props.name + '</p>' )
									.prependTo( pm.$msgs )
							}
							fullHistoryCount = count
						})
				}).catch( ( err ) => {
					console.log( err )
				})

			let fetchingHistory = false

			pm.$msgs.on( 'wheel', function( e ){
				const delta = e.originalEvent.deltaY // <0 is up, >0 is down
				if( delta < 0 && $pmTop.scrollTop() === 0 ){
					fetchingHistory = true
					db.msgs.where({userid: pm.from.props.id, otherid: pm.to.props.id})
						.and( function( x ){ return x.date < lastHistoryDate })
						.reverse()
						.limit( 25 )
						.toArray()
						.then( ( rows ) => {
							rows.forEach( ( row ) => {
								appendHistory( row )
							})
							fetchingHistory = false
						})
						.catch( ( err ) => {
							console.log( err )
						})
						.finally( () => {
							pm.$msgs.find( '.top-response' )
								.prependTo( pm.$msgs )

							if( totalHistory === fullHistoryCount ){
								pm.$msgs.find( '.top-response' ).html( '<span class="ui-icon ui-icon-info" style="float: left; margin-right: .3em;"></span>This is the beginning of your message history with ' + pm.to.props.name )
							}
						})
				}
			})
		}
		return this
	}
	Pm.prototype.prependMsg = function( html, date ){
		date = date || Date.now()
		const $el = $( `<div class="message-line">${html}</div>` ).addClass( 'date-' + date )
		this.$msgs.prepend( $el )

		$el.find( '.has-image' ).each( function(){
			const $this = $( this ),
				img = new Image()
			img.src = $( this ).attr( 'href' )
			$( img ).on( 'load', function(){
				if( img.width <= 70 && img.height <= 50 ){
					$this.replaceWith( img )
				}
			})
		})

		return $el
	}
	Pm.prototype.appendMsg = function( html, date ){
		date = date || Date.now()
		const $el = $( `<div class="message-line">${html}</div>` ).addClass( 'date-' + date )
		this.$msgs.append( $el )
		if( this.$typing ){
			$el.insertBefore( this.$typing )
		}
		$pmTop.animate({scrollTop: '+=' + ( $el.outerHeight() + 18 )}, 250 )

		$el.find( '.has-image' ).each( function(){
			const $this = $( this ),
				img = new Image()
			img.src = $( this ).attr( 'href' )
			$( img ).on( 'load', function(){
				if( img.width <= 70 && img.height <= 50 ){
					$this.replaceWith( img )
				}
			})
		})

		return $el
	}
	rph.getPmIfExists = function( users ){
		return typeof rph.pms['from' + users.from + 'to' + users.to] === 'object' ? rph.pms['from' + users.from + 'to' + users.to] : false
	}
	rph.getPm = function( users, callback, silent ){
		getUserById( users.to, function( user ){
			getUserById( users.from, function( fromUser ){
				const pm = rph.getPmIfExists({from: users.from, to: users.to}) || new Pm( user, silent ).setFrom( fromUser ) // fix for race condition of trying to getPm twice without having fetched username
				if( callback && typeof callback !== 'undefined' ){
					callback( pm )
				} else {
					console.log( 'getPm why was callback undefined?' )
				}
			})
		})
	}
	function escapeRegExp( str ){
		return str.replace( /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&' )
	}
	global.parseMsg = function( msg ){
		if( msg.charAt( 0 ) === '/' && msg.toLowerCase().slice( 1, 3 ) === 'me' ){
			msg = msg.slice( 3 )
		}

		msg = msg.replace( /</g, '&lt;' )
		msg = msg.replace( />/g, '&gt;' )
		msg = msg.replace( /="/g, '' )

		// form a list of URLs before they're molested
		const anchors = msg.match( /<a.+<\/a>/ ),
			wrapTags = ( startTag, endTag, outerMatch, innerMatch ) => {
				if( innerMatch.charAt( 0 ) === ' ' || innerMatch.charAt( innerMatch.length - 1 ) === ' ' || innerMatch.length === 0 ){
					return outerMatch
				}
				return startTag + innerMatch + endTag
			}

		msg = msg.replace( /(")(.*?)(")/g,
			( outerMatch, p1, innerMatch, s ) =>
				wrapTags( '<span class="dialog-quote">"', '"</span>', outerMatch, innerMatch ) )

		msg = Anchorme( msg, {
			exclude: function( urlObj ){
				urlObj.encoded = urlObj.encoded.replace( /%25/g, '%' )
				return false
			},
			truncate: [26, 15], // add this later to pretty up the url up to the first / and then just a bit of the end
			attributes: [
				{name: 'target', value: '_blank'},
				function( urlObj ){
					if( urlObj.raw.endsWith( '.jpg' ) ||
						urlObj.raw.endsWith( '.jpeg' ) ||
						urlObj.raw.endsWith( '.png' ) ){
						return {name: 'class', value: 'has-image'}
					}
				}
			]
			// using a function later to parse out different types of urls
		})

		msg = msg.replace( /(\-\-\-)/g, '&mdash;' )
		msg = msg.replace( /(\[b\]|\*\*)(.*?)(\[\/b\]|\*\*)/g, '<strong>$2</strong>' )
		msg = msg.replace( /(\[s\]|\-\-|~~)(.*?)(\[\/s\]|\-\-|~~)/g, '<strike>$2</strike>' )
		msg = msg.replace( /(\[sup\]|\^\^)(.*?)(\[\/ssup\]|\^\^)/g,
			( outerMatch, p1, innerMatch, s ) =>
				wrapTags( '<sup>', '</sup>', outerMatch, innerMatch ) )
		msg = msg.replace( /(\[sub\]|vv)(.*?)(\[\/sub\]|vv)/g,
			( outerMatch, p1, innerMatch, s ) =>
				wrapTags( '<sub>', '</sub>', outerMatch, innerMatch ) )
		msg = msg.replace( /(\[u\]|__)(.*?)(\[\/u\]|__)/g, '<u>$2</u>' )
		msg = msg.replace( /(\[spoiler\]|!\!)(.*?)(\[\/spoiler\]|\!\!)/g,
			( outerMatch, p1, innerMatch, s ) =>
				wrapTags( '<span class="spoiler">', '</span>', outerMatch, innerMatch ) )
		msg = msg.replace( /(?:\[i\]|\/\/)([^\/].*?)(?:\[\/i\]|\/\/)/g, function( str, p1, offset, s ){ if( s.charAt( offset - 1 ) === ':' ){ return str } else { return '<em>' + $( '<div>' + p1 + '</div>' ).text() + '</em>' } }) // don't mess with urls

		if( anchors && anchors.length !== 0 ){
			const potentiallyMolested = msg.match( /<a.+<\/a>/ )
			potentiallyMolested.forEach( function( URL, i ){
				if( URL !== anchors[i] ){
					msg = msg.replace( URL, anchors[i] )
				}
			})
		}

		msg = msg.replace( /\n/g, '<br>' ) // has to be after link stuff or it'll eat links

		return msg
	}
	$( '#pm-dialog, #menus' ).on( 'click', '.room-link', function(){
		const roomname = $( this ).text()
		rph.UserSelector.attachTo( $( this ), function( User ){
			socket.emit( 'join', {name: roomname, userid: User.props.id})
		})
	})
	Pm.prototype.typingStart = function(){
		const pm = this
		if( !this.$typing ){
			this.$typing = $( '<div class="typing-notify dull">' + pm.to.props.name + ' is writing...</div>' )
				.appendTo( pm.$msgs )
		} else {
			this.$typing.css( 'visibility', 'visible' )
		}
		$pmTop.animate({scrollTop: '+=' + this.$typing.outerHeight()}, 0 )
		this.$tab.addClass( 'typing' )
	}
	Pm.prototype.typingStop = function(){
		if( this.$typing ){
			this.$typing.css( 'visibility', 'hidden' )
		}
		this.$tab.removeClass( 'typing' )
	}
	socket.on( 'typing-start', function( data ){
		const pm = rph.getPmIfExists({from: data.from, to: data.to})
		if( pm ){
			pm.typingStart()
		}
	})
	socket.on( 'typing-end', function( data ){
		const pm = rph.getPmIfExists({from: data.from, to: data.to})
		if( pm ){
			pm.typingStop()
		}
	})
	socket.on( 'pm', function( data ){
		getUserById( data.to, function( fromUser ){
			if( fromUser.blocked ){
				return
			}
			rph.getPm({from: data.from, to: data.to}, function( pm ){
				if( pm.$typing ){
					pm.$typing.remove()
					delete pm.$typing
				}
				const date = data.date ? data.date : unixtime()
				let classes = ''
				const message = parseMsg( data.msg )
				let me = false
				if( data.msg.charAt( 0 ) === '/' ){
					if( data.msg.toLowerCase().indexOf( 'me' ) === 1 ){
						me = true
						classes += 'action '
					}
				}
				const $el = pm.appendMsg( '<div class="message-right" /><p><span class="timestamp" data-unixtime="' + date + '" data-userid="' + pm.to.props.id + '">' + makeTimestamp( date ) + '</span><strong class="name">&nbsp;' + ( pm.to.props.vanity || pm.to.props.name ) + ( me ? '' : '&nbsp;' ) + '</strong><span class="message" data-unparsed="' + quoteAttr( data.msg ) + '">' + message + '</span></p>' )
					.addClass( classes )
				if( accountFns.isOwnUser( account, data.to ) ){
					$el.find( '.message-right' ).append( '<a class="slider">⋮</a>' )
				}

				if( ( $pmDialog.activePm !== pm && !pm.unread ) || ( !$pmDialog.dialog( 'isOpen' ) && !pm.unread ) ){
					pm.setUnread()
				}
				if( activeWindow && pm.unread && $pmDialog.activePm === pm ){
					pm.setRead( 'pm' )
				}
				playSound()
				db.msgs.put({date: data.serverD || date, fromid: pm.to.props.id, userid: data.from, otherid: data.to, msg: data.msg})

				if( account.settings.notifyPm ){
					desktopNotify( 'PM from ' + ( pm.to.props.vanity || pm.to.props.name ), data.msg )
				}
			})
		})
	})
	socket.on( 'pm-alert', function( data ){
		rph.getPm({from: data.to, to: data.from}, function( pm ){
			pm.appendMsg( '<p>' + parseMsg( data.msg ) + '</p>' )
		})
	})
	socket.onOutgoing( 'pm', function( data ){
		rph.getPm({from: data.from, to: data.to}, function( pm ){
			const date = data.date ? data.date : Date.now()
			let classes = ''
			const message = parseMsg( data.msg )
			let me = false
			if( data.msg.charAt( 0 ) === '/' ){
				if( data.msg.toLowerCase().indexOf( 'me' ) === 1 ){
					me = true
					classes += 'action '
				}
			}
			pm.appendMsg( '<div class="message-right" title="attempting to send this message..." /><p><span class="timestamp" data-unixtime="' + date + '" data-userid="' + pm.from.props.id + '">' + makeTimestamp( date ) + '</span><strong class="name">&nbsp;' + ( pm.from.props.vanity || pm.from.props.name ) + ( me ? '' : '&nbsp;' ) + '</strong><span class="message" data-unparsed="' + quoteAttr( data.msg ) + '">' + message + '</span></p>', date )
				.addClass( 'sending' )
				.addClass( classes )
			if( pm.to.blocked ){
				pm.appendMsg( '<p>You have ' + ( pm.to.props.vanity || pm.to.props.name ) + ( pm.to.props.vanity ? ' <span class="small">a.k.a. ' + pm.to.props.name + '</span>' : '' ) + ' blocked. Right click their name in the "Blocked" section of your friends list to unblock them.</p>' )
			} else {
				db.msgs.put({date: data.serverD || date, fromid: data.from, userid: pm.from.props.id, otherid: pm.to.props.id, msg: data.msg}) // serverD doesn't work here. need a better solution
			}
		})
	})
	socket.on( 'pm-confirmation', function( data ){
		if( accountFns.isOwnUser( account, data.to ) ){
			rph.getPm({from: data.to, to: data.from}, function( pm ){
				if( pm.$msgs.find( '.date-' + data.date ).hasClass( 'sending' ) ){
					pm.$msgs.find( '.date-' + data.date ).removeClass( 'sending' ).removeAttr( 'title' )
						.find( '.message-right' ).append( '<a class="slider">⋮</a>' )
				} else {
					const date = data.date ? data.date : unixtime()
					let classes = ''
					const message = parseMsg( data.msg )
					let me = false
					if( data.msg.charAt( 0 ) === '/' ){
						if( data.msg.toLowerCase().indexOf( 'me' ) === 1 ){
							me = true
							classes += 'action '
						}
					}
					const $el = pm.appendMsg( '<div class="message-right"><a class="slider">⋮</a></div><p><span class="timestamp" data-foo="bar" data-unixtime="' + date + '" data-userid="' + pm.from.props.id + '">' + makeTimestamp( date ) + '</span><strong class="name">&nbsp;' + pm.from.props.name + ( me ? '' : '&nbsp;' ) + '</strong><span class="message" data-unparsed="' + quoteAttr( data.msg ) + '">' + message + '</span></p>' ).addClass( classes )
				}
			})
		}
	})

	$( 'body' ).on( 'click', '.msger-user', function(){
		const $this = $( this )
		getUserByName( $this.text(), ( user ) => {
			$this.replaceWith( user.$createEl().addClass( 'open-pm' ) )
		})
	})
	socket.on( 'account', ( data ) => {
		setTimeout( () => {
			console.log( 'account', data )

			$dockBtns.show()

			if( data.props && data.props.ukey ){
				console.log( 'account ukey update', data.props.ukey )
				const date = new Date(),
					oneMonth = new Date( date.setMonth( date.getMonth() + 3 ) ),
					host = window.location.hostname.split( '.' ).slice( -2 ).join( '.' )

				document.cookie = `uniquekey=${account.props.ukey}; Path=/; Expires=${oneMonth.toGMTString()};samesite=lax;domain=${host}`
			}
			if( account.props.sub ){
				$( '.subscriber-lockout-modal' ).hide()
			}

			initDb( account.props.accid ) // set db variable

			db.version( 1 ).stores({
				msgs: '&[date+fromid+userid], [userid+otherid], userid, date'
			})
			db.version( 2 ).stores({
				msgs: '&[date+fromid+userid], [userid+otherid], [fromid+date], userid, date'
				// msg 		- message,
				// &[date,fromid]	- (date, sender userid)(unique pair)
				// historicalNames: '&id,name,d'
			})

			for( const [key, value] of Object.entries( settings ) ){
				account.settings[key] = value
				rph.handleSetting( key, value )
			}

			$pmDialog.dialog( 'option', 'width', account.settings.pmSize.width )
			$pmDialog.dialog( 'option', 'height', account.settings.pmSize.height )
			if( account.settings.pms.length > 0 ){
				account.settings.pms.forEach( ( pmKey ) => {
					rph.getPm({from: pmKey.from, to: pmKey.to}, function( pm ){
						if( pmKey.unread === true ){
							pm.setUnread()
						}
						$pmDialog.dialog( 'close' )
					})
				})
			}

			setTimeout( function(){
				if( account.userids.length === 0 ){
					console.log( '!!! requesting new session' )
					socket.emit( 'request-session' )
				}
			}, 1500 )
		}, 500 )
	})

	socket.on( 'could-not-fetch', ( data ) => {
		console.log( 'could-not-fetch', data )
	})
	socket.on( 'update-user', ( data ) => {
		getUserById( data.id, ( user ) => {
			if( typeof data.animateIcon !== 'undefined' ){
				user.lastUploadEpoch = Date.now()
			}
			user.modify( data )
		})
	})
	socket.on( 'update-user-priv', ( data ) => {
		for( const userid in data ){
			for( const [key, value] of Object.entries( data[userid] ) ){
				if( key === 'friends' ){
					getUserById( userid, ( user ) => {
						user.priv.friends = value
					})
				}
			}
		}
	})

	{
		const $settingsDialog = $( '<div id="settings-dialog" class="modal"><rph-settings :account="account" /></div>' ).appendTo( 'body' ).hide()

		global.settingsVue = createVue({
			data: () => ({
				account: account
			}),
			components: {
				'rph-settings': Settings
			}
		})
			.mount( '#settings-dialog' )

		$( 'body' ).on( 'click', '.settings', function( ev ){
			ev.preventDefault()
			$settingsDialog.show()
				.find( '.tabs a[href="#account-settings"]' ).click()
		})

		$( 'body' ).on( 'click', '.subscriber-lockout-modal a', function( ev ){
			ev.preventDefault()
			$settingsDialog.show()
				.find( '.tabs a[href="#account-settings"]' ).click()
		})
	}

	socket.on( 'remove-account', ( data ) => {
		if( data.ids ){
			data.ids.forEach( ( rmId ) => {
				!( account.userids.indexOf( rmId ) !== -1 ) && account.userids.splice( account.userids.indexOf( rmId ), 1 ) // remove from array if exists
				account.users.forEach( ( user, index ) => {
					if( user.props.id === rmId ){
						account.users.splice( index, 1 )
					}
				})
			})
		}
	})
	socket.on( 'deleted-user-data', ( data ) => {
		if( data.ids ){
			data.ids.forEach( ( newId ) => {
				if( account.deletedUserids.indexOf( newId ) === -1 ){
					account.deletedUserids.unshift( newId )
					getUserById( newId, ( user ) => {
						account.deletedUsers.unshift( user )
					})
				}
			})
		}
	})
	socket.on( 'remove-deleted-user-data', ( data ) => {
		if( data.ids ){
			data.ids.forEach( ( rmId ) => {
				!( account.deletedUserids.indexOf( rmId ) !== -1 ) && account.deletedUserids.splice( account.deletedUserids.indexOf( rmId ), 1 )
				account.deletedUsers.forEach( ( user, index ) => {
					if( user.props.id === rmId ){
						account.deletedUsers.splice( index, index )
					}
				})
			})
		}
	})
	socket.on( 'transactions', function( data ){
		account.transactions = ( data || [] ).reverse()
	})
	socket.on( 'ignores', function( data ){
		account.ignores = [...new Set( [...account.ignores, ...data.ids] )] // Array.from( new Set(account.ignores.concat(data.ids)) ) //unique combine / _.union
		data.ids.forEach( ( id ) => {
			getUserById( id, function( user ){
				user.setBlocked( user )
			})
		})
	})

	socket.on( 'friend-invite', function( data ){
		getUserById( data.from, function( fromUser ){
			getUserById( data.to, function( toUser ){
				fromUser.showInvite( toUser )
			})
		})
	})

	socket.on( 'remove-user', function( data ){
		let foundi = account.ignores.indexOf( data.id )
		account.ignores.splice( foundi, foundi !== -1 )

		foundi = account.userids.indexOf( data.id )
		account.userids.splice( foundi, foundi !== -1 )
	})

	socket.on( 'reconnect', () => {
		console.log( 'reconnected. Resubbing to', Object.keys( messenger.users ).length, Object.keys( messenger.users ) )
		socket.emit( 'userSubscribe', {userids: Object.keys( messenger.users ), usernames: []})
	})

	socket.on( 'reconnecting', function(){
		if( !$( '.reconnecting' )[0] ){
			const $el = $( '<div id="right-alert" class="container dock right reconnecting"><div /></div>' ).appendTo( 'body' )
			$( '<p>Disconnected. Attempting to reconnect...</p>' ).prependTo( $el )
		} else {
			$( '.reconnecting p' ).text( 'Disconnected. Attempting to reconnect...' )
		}
	})
	socket.on( 'connect', function(){
		console.log( 'connect' )
		$( '.reconnecting' ).remove()
		connected = true

		setTimeout( function(){
			if( account.userids.length === 0 ){
				console.log( '!!! requesting new session' )
				socket.emit( 'request-session' )
			}
		}, 2500 )
	})
	socket.on( 'disconnect', function(){
		// !!! resubscribe manually here on reconnect as a stop-gap for proper stateful update

		if( !$( '.reconnecting' )[0] ){
			const $el = $( '<div id="right-alert" class="container dock right reconnecting"><div /></div>' ).appendTo( 'body' )
			$( '<p>Messenger not connected.</p>' ).prependTo( $el )
		} else {
			$( '.reconnecting p' ).text( 'Messenger not connected.' )
		}

		connected = false
	})

	rph.loginDialog = new rph.CustomDialog( 'Login',
		`<div>
			<login-form />
		</div>`,
		{draggable: false, resizable: false, width: 500, height: 550}
	)
	const loginVue = createVue({
		data: () => ({
			user: false
		}),
		components: {
			loginForm: loginFormVue
		}
	})
		.mount( rph.loginDialog.$el[0] )
	$( '#login-dialog' )[0].Vue = loginVue

	rph.errorDialog = new rph.CustomDialog( 'Error',
		'<div class="ui-corner-all ui-state-error" style="padding:5px;"><p class="ui-state-default msg" /></div>',
		{width: 350, height: 150})
	socket.on( 'error-msg', ( data ) => {
		if( ( data.errorid === 103 || data.errorid === 902 ) && !account.props.ukey ){ // not logged in. Prompt to login/register
			rph.loginDialog.show()
			return
		}
		console.log( 'RPH error', data )
		let msg = data.msg
		switch ( data.errorid ){
			case 700:
				msg = 'Truncated; basic accounts are limited to status messages 20 characters long. You may purchase credit or subscribe via your account page to increase this to 100.'
				break
			case 701:
				msg = 'Truncated; status messages are limited to 100 characters long. Post a LFRP ad for something longer.'
				break
			case 303:
				msg = 'That character name is already in use'
				break
			case 304:
				msg = 'That character name isn\'t valid; must start and end with a letter or number, and may contain letters, numbers, spaces, periods, and dashes. Non-letter characters must not appear adjacent to the same character.'
				break
			case 401:
				setTimeout( () => {
					location.reload( true )
				}, 30 * 60 * 1000 )
				break
		}
		rph.errorDialog.show()
		rph.errorDialog.$el.find( '.msg' ).html( '<span>errorid:' + data.errorid + ' - ' + msg + '</p>' )
	})
	const massMsgDialog = new rph.CustomDialog( 'Mass Message',
			`<p class="ui-corner-all ui-state-highlight">Below is an important message.</p>
			<div class="ui-corner-all ui-state-highlight msgs"></div>`,
			{width: 350, height: 350, position: {my: 'top', at: 'top+100'}}),
		$miniModal = $( '<div class="mini-modal notifications" style="display:none;" />' ).insertBefore( massMsgDialog.$el.parent() )
	massMsgDialog.onOpen( () => {
		$miniModal.empty()
		$miniModal.show()
	})
	function bellRand(){
		return ( Math.pow( 2 * Math.random() - 1, 3 ) / 2 ) + 0.5
	}
	socket.on( 'mass-msg', function( data ){
		rph.alerted = true
		massMsgDialog.show()
		massMsgDialog.$el.find( '.msgs' ).prepend( '<p>[' + makeTimestamp() + ']' + data.username + ': ' + parseMsg( data.msg ) )
		massMsgDialog.$el.find( '.msgs p:first .has-image' ).each( function(){
			const $this = $( this ),
				img = new Image()
			img.src = $( this ).attr( 'href' )
			$( img ).on( 'load', function(){
				if( img.width <= 70 && img.height <= 50 ){
					$this.replaceWith( img )
				}
			})
		})
		if( data.type === 'ping' ){
			const intervals = []
			intervals.push( setInterval( function(){
				let rand1 = bellRand() * 100,
					rand2 = bellRand() * 100
				rand1 = rand1 < 65 && rand1 > 50 ? rand1 + 15
					: rand1 > 35 && rand1 < 50 ? rand1 - 15
						: rand1
				rand2 = rand2 < 60 && rand2 > 40 ? rand2 + Math.random() * 30 - 15 : rand2
				$( '<span class="ping">!</span>' )
					.css({position: 'absolute', left: rand1 + '%', top: rand2 + '%'})
					.appendTo( $miniModal )
			}, 10 ) )
			intervals.push( setInterval( function(){
				let rand1 = bellRand() * 100,
					rand2 = bellRand() * 100
				rand1 = rand1 < 65 && rand1 > 50 ? rand1 + 15
					: rand1 > 35 && rand1 < 50 ? rand1 - 15
						: rand1
				rand2 = rand2 < 60 && rand2 > 40 ? rand2 + Math.random() * 30 - 15 : rand2
				const $el = $( '<span class="ping">!</span>' )
					.css({position: 'absolute', left: rand1 + '%', top: rand2 + '%'})
					.appendTo( $miniModal )
			}, 14 ) )
			setTimeout( function(){
				intervals.forEach( function( interval ){
					clearInterval( interval )
				})
			}, 4000 )
			massMsgDialog.$el.parent().effect( 'shake', {direction: 'up'})
			massMsgDialog.onClose( function(){
				$miniModal.empty()
				$miniModal.hide()
			})
			drawIcon()
			rph.sounds.squawk.play()
		} else if( data.type === 'silent' ){

		} else {
			rph.sounds.squawk.play()
		}
	})

	/* socket.on('show-news', function(){
		$('<div id="newsDialog" title="Oh hi, I intentionally changed your everything"><div class="inner ui-corner-bottom">
			<img src="//img.rphaven.com/th_1.png" style="float:left;" /><h1>RPH has changed a lot since you last used it.</h1><p><em>Psst. This\'ll only show up once, so read it.</em></p>
			<p>I thought there were a lot of problems with keeping track of your friends, juggling many different accounts, and some things could be confusing to new users such as how to message someone that\'s not online.</p>
			<p> Now you can PM someone from any page, whether you\'re viewing a profile, searching for profiles, on the forums, or in the chat. A <img src="//img.rphaven.com/msg.png" /> icon shows when you can click to open a profile, or have the right click menu show up.  You also have all your names together in one friends list and PM box. Because of how much time and effort this alone took, I don\'t have the same incorporated into the chat(yet).</p>
			<h1>With the new messenger also comes some bugs:</h1><p>There are issues with the friends list, mainly when you add one person under multiple names of yours, or if you add your own names to your friends list. The pm box will sometimes pop up on a new page load.  This is because new pms pop up on the active window, and they are considered new when your current pms are restored on the page load.  You can get around this by ctrl+click on PM links so they open in the background and then waiting for them to load before changing tabs to them. The list of users in your logs could not be transfered from the chat, but your logs are all there. One you message someone missing from there, they\'ll show up. Changes to thumbnails don\'t show up, and handling of deleted users needs work. Name colors on chat userlist no longer show.<br>These are things that I\'ll fix very soon(except the logs one), and I have improvements to make, but I\'m exhausted and need a break!</p><p>&nbsp;</p>
			<p>As always, you can support RPH and help bring in more improvements by <a href="//www.rphaven.com/donate.php">donating<a/>, and <a href="//www.rphaven.com/">telling others</a>.</p>').dialog({width:625, height:450});
	}); */
})

global.socket = socket
